import {
  FaWallet,
  FaRegClock,
  FaRegUser,
  FaFileInvoiceDollar,
} from "react-icons/fa";
import { BiWalletAlt, BiTransfer } from "react-icons/bi";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { CgKeyhole } from "react-icons/cg";
import { TbTransferIn } from "react-icons/tb";
import { IoMdSettings } from "react-icons/io";
import { MdOutlineAccountBalance, MdOutlineWhatsapp } from "react-icons/md";
import HomeIcon from "../assets/images/home.png";
import casinoIcon from "../assets/images/casino.png";
import sportIcon from "../assets/images/sports.png";
import leadgeIcon from "../assets/images/leadge.png";
import betsIcon from "../assets/images/mybets.png";
import gameImage from "../assets/images/game1.png";
import gameImage1 from "../assets/images/game2.png";
import gameImage2 from "../assets/images/game3.png";
import gameImage3 from "../assets/images/game4.png";
import gameImage4 from "../assets/images/game5.png";

import banner1 from "../assets/images/banner-3.webp";
import banner2 from "../assets/images/kv-casino.webp";
import banner3 from "../assets/images/kv-netent.webp";
import banner4 from "../assets/images/kv-spribe.webp";
import banner5 from "../assets/images/kv-JDB-e-game.webp";
import banner6 from "../assets/images/kv-hotroad.webp";
import banner7 from "../assets/images/kv-smartsoft.webp";

// hotgame Image
import jilifortunegems500 from "../assets/images/hot-casino/provider-jilifortunegems500.png";
import jililuckytiger from "../assets/images/hot-casino/provider-jililuckytiger.png";
import jilisuperace from "../assets/images/hot-casino/provider-jilisuperace.png";
import crashaviatorheyvip from "../assets/images/hot-casino/provider-crashaviatorheyvip.png";
import superelementsfc from "../assets/images/hot-casino/provider-superelementsfc.png";
import jiliboxingking from "../assets/images/hot-casino/provider-jiliboxingking.png";
import aviator2 from "../assets/images/hot-casino/provider-aviator2.png";
import wmatchodds from "../assets/images/hot-casino/provider-9wmatchodds.png";
import jilisuperacedeluxe from "../assets/images/hot-casino/provider-jilisuperacedeluxe.png";
import jilifortunegems2 from "../assets/images/hot-casino/provider-jilifortunegems2.png";
import jilimoneycoming from "../assets/images/hot-casino/provider-jilimoneycoming.png";
import evocrazytime from "../assets/images/hot-casino/provider-evocrazytime.png";
import jilifortunegems3 from "../assets/images/hot-casino/provider-jilifortunegems3.png";
import pgwildbountry from "../assets/images/hot-casino/provider-pgwildbountry.png";
import jilifortunegems from "../assets/images/hot-casino/provider-jilifortunegems.png";
import jili7up7down from "../assets/images/hot-casino/provider-jili7up7down.png";
import magicacewildlock from "../assets/images/hot-casino/provider-magicacewildlock.png";
import ybcrazymoney from "../assets/images/hot-casino/provider-ybcrazymoney.png";
import r88moneyrolling from "../assets/images/hot-casino/provider-r88moneyrolling.png";
import jilimegaace from "../assets/images/hot-casino/provider-jilimegaace.png";
import jilimoneycomingEB from "../assets/images/hot-casino/provider-jilimoneycomingEB.png";
import jilicrazy777 from "../assets/images/hot-casino/provider-jilicrazy777.png";
import jiliwildace from "../assets/images/hot-casino/provider-jiliwildace.png";
import jdbpiggybank from "../assets/images/hot-casino/provider-jdbpiggybank.png";
import jilichargebuffalo from "../assets/images/hot-casino/provider-jilichargebuffalo.png";
import jdbmagicace from "../assets/images/hot-casino/provicer-jdbmagicace.png";
import ybroyalae from "../assets/images/hot-casino/provider-ybroyalae.png";
import ybrolling7 from "../assets/images/hot-casino/provider-ybrolling7.png";
import r88luckace from "../assets/images/hot-casino/provider-r88luckace.png";
import r88777 from "../assets/images/hot-casino/provider-r88777.png";
export const sidebarData = [
  {
    firstLevel: [
      {
        id: 1,
        menu: "Deposit",
        icon: <i class="icon icon-funds"></i>,
        link: "/deposit",
      },
      {
        id: 2,
        menu: "Payment Transfer log",
        icon: <i class="icon icon-payment-transfer-log"></i>,
        link: "/p2p-transfer-log",
      },
    ],

    secondLevel: [
      {
        id: 1,
        menu: "Upline Whatsapp Number",
        icon: <i class="icon icon-whatsapp-line"></i>,
        link: "/upline-whatsapp-number",
      },
      {
        id: 2,
        menu: "Balance Overview",
        icon: <i class="icon icon-wallet"></i>,
        link: "/balance-overview",
      },
      {
        id: 3,
        menu: "Account Statement",
        icon: <MdOutlineAccountBalance />,
        link: "/account-statement",
      },
      {
        id: 4,
        menu: "Current Bets",
        icon: <i class="icon icon-list"></i>,

        link: "/current-bets",
      },
      {
        id: 5,
        menu: "Bets History",
        icon: <i class="icon icon-history"></i>,
        link: "/bets-history",
      },
      {
        id: 6,
        menu: "Profit & Loss",
        icon: <i class="icon icon-profit-loss"></i>,
        link: "/profit-and-loss",
      },
      {
        id: 7,
        menu: "Active Log",
        icon: <i class="icon icon-active-log"></i>,
        link: "/active-log",
      },
      {
        id: 8,
        menu: "My Profile",
        icon: <i class="icon icon-profile"></i>,
        link: "/my-profile",
      },
    ],
  },

  {
    thirdLevel: [
      {
        id: 8,
        menu: "P2P Transfer",
        icon: <i class="icon icon-transfer"></i>,
        link: "/p2p-transfer",
      },
      {
        id: 9,
        menu: "P2P Transfer log",
        icon: <i class="icon icon-transfer-log"></i>,
        link: "/p2p-transfer-log",
      },
    ],
  },

  {
    fourthLevel: [
       {
        id: 10,
        menu: "Spin Report",
        icon: <i class="icon icon-catalog"></i>,
        link: "/spin-report",
      },
        {
        id: 11,
        menu: "Referral",
        icon: <i class="icon icon-pdf"></i>,
        link: "/referral",
      },
      {
        id: 12,
        menu: "Setting",
        icon: <i class="icon icon-setting"></i>,
        link: "/setting",
      },
    ],
  },
];

export const bottomNavigation = [
  {
    id: "1",
    menu: "Home",
    icon: HomeIcon,
    link: "/",
  },
  {
    id: "2",
    menu: "Casino",
    icon: casinoIcon,
    link: "/casino",
  },
  {
    id: "3",
    menu: "Sports",
    icon: sportIcon,
    link: "/sports",
  },
  {
    id: "4",
    menu: "Leagues",
    icon: leadgeIcon,
    link: "/leagues",
  },
  {
    id: "5",
    menu: "My Bets",
    icon: betsIcon,
  },
];

export const gamesLiveArray = [
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-435.webp",
    thumbnail: "https://bshots.egcvi.com/thumbnail/supercolorgame.webp",
    name: "Super Color Game",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-435",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-434.webp",
    thumbnail: "https://bshots.egcvi.com/thumbnail/marblerace.webp",
    name: "Marble Race",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-434",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/live/evo/EVOLUTION-LIVE-205.png",
    thumbnail:"https://bshots.egcvi.com/thumbnail/xxxtreme_roulette.webp",
    name: "XXXtreme Lightning roulette",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-205",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
 {
    img: "../assets/images/game-shows/GAME-SHOW-3.webp",
    name: "Funky Time",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-183",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
{
    img: "../assets/images/game-shows/GAME-SHOW-4.webp",
    name: "Dead or Alive Saloon",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-176",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
{
    img: "../assets/images/game-shows/GAME-SHOW-5.webp",
    name: "Crazy Time",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
{
    img: "../assets/images/game-shows/GAME-SHOW-6.webp",
    name: "Lightning Dice",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-011",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-7.webp",
    name: "Lightning Roulette",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-040",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
{
    img: "../assets/images/game-shows/GAME-SHOW-8.webp",
    name: "Lightning Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-133",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-9.webp",
    name: "Extra Chilli",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-168",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-10.webp",
    name: "Imperial Quest",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-169",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },

  {
    img: "../assets/images/game-shows/GAME-SHOW-11.webp",
    name: "Monopoly Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-007",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-12.webp",
    name: "Monopoly Big Baller",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-018",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
{
    img: "../assets/images/game-shows/EVOLUTION-LIVE-291.webp",
    name: "Stock Market",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-291",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-292.webp",
    name: "Stock Market",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-292",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-13.webp",
    name: "Crazy Coin Flip",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-014",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-14.webp",
    name: "Mega Ball",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-010",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-27.webp",
    name: "Sicbo Delux",
    gameType: "LIVE",
    platForm: "PLAYTECH",
    casinoType: "PT-PLAYTECH-003",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-16.webp",
    name: "Wounderland",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-011",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-18.webp",
    name: "Spin a Win Wild live",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-015",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },
   {
    img: "../assets/images/game-shows/GAME-SHOW-21.webp",
    name: "Mega Wheel",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-038",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },


  {
    img: "../assets/images/game-shows/GAME-SHOW-23.webp",
    name: "Mega Roulette 500x",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-039",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-24.webp",
    name: "Mega Baccarat",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-061",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },
 {
    img: "../assets/images/game-shows/GAME-SHOW-25.webp",
    name: "Quantum Auto Roulette",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-026",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },
{
    img: "../assets/images/game-shows/GAME-SHOW-17.webp",
    name: "Shweet Bonanza Candy Land",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-044",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/PP-LIVE-075.webp",
    name: "Auto Mega Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-075",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-28.webp",
    name: "Mega Sicbo",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-025",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/PP-LIVE-077.webp",
    name: "Lucky 6 Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-077",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/PP-LIVE-076.webp",
    name: "Lucky 6 Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-076",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },




  {
    img: "../assets/images/game-shows/GAME-SHOW-5.webp",
    name: "Crazy Time",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-11.webp",
    name: "Monopoly Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-007",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-3.webp",
    name: "Funky Time",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-183",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
     {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-204.webp",
    name: "Andar Bahar",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-204",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
   {
    img: "../assets/images/Egame/JDB-EGAME-011.webp",
    name: "Jogo Do Bicho",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-013",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-010.webp",
    name: "Beer Tycoon",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-014",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },

  {
    img: "../assets/images/Egame/JDB-EGAME-002.webp",
    name: "Lucky Color Game",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-009",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-006.webp",
    name: "King Of Football",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-010",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-001.webp",
    name: "Crazy King Kong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-011",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },

  {
    img: "../assets/images/Egame/JDB-EGAME-007.webp",
    name: "Super Super Fruit",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-012",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },

{
    img: "../assets/images/JILI/JILI-TABLE-041.png",
    name: "Plinko",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-041",
    cateogry: "HOT",
   type: "HOT",
    isPopular: true,
  },

{
    img: "../assets/images/JILI/JILI-TABLE-032.webp",
    name: "HILO",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-032",
    cateogry: "HOT",
   type: "HOT",
    isPopular: true,
  },
 {
    img: "../assets/images/slot/JILI-SLOT-029.webp",
    name: "Money Coming",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-029",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/slot/JILI-SLOT-017.webp",
    name: "Crazy FaFaFa",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-017",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/JILI/JILI-TABLE-005.webp",
    name: "NumberKing",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-005",
    cateogry: "JIHOTLI",
    type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/slot/JILI-SLOT-027.webp",
    name: "Super Ace",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },

 {
    img: "../assets/images/Table/KM-TABLE-021.webp",
    name: "Number Matka",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-021",
    cateogry: "KINGMAKER",
     type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Table/KM-TABLE-032.webp",
    name: "Andar Bahar",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-032",
    cateogry: "KINGMAKER",
     type: "HOT",
    isPopular: true,
  },

  {
    img: "../assets/images/Table/TABLE-6.webp",
    name: "Coin Toss",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-036",
    cateogry: "KINGMAKER",
     type: "HOT",
    isPopular: true,
  },

 {
    img: "../assets/images/Egame/PP-EGAME-007.webp",
    name: "Darts",
    platForm: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-007",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
 {
    img: "../assets/images/Egame/PP-EGAME-006.webp",
    name: "Force 1",
    platForm: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-006",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/Egame/PP-EGAME-005.webp",
    name: "Greyhound Racing",
    platForm: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-005",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/Egame/PP-EGAME-004.webp",
    name: "Fantastic League",
    platForm: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-004",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/Egame/PP-EGAME-003.webp",
    name: "Horse Racing",
    platForm: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-002",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/Egame/PP-EGAME-002.webp",
    name: "Penalty Shootout",
    platForm: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-002",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },

{
    img: "../assets/images/Egame/PP-LIVE-025.webp",
    name: "Mega Sic Bo",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-025",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Egame/PP-LIVE-038.webp",
    name: "Mega WHeel",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-038",
    cateogry: "PP",
     type: "HOT",
    isPopular: true,
  },

{
    img: "../assets/images/Baccarat/BACCARAT-7.webp",
    name: "Baccarat Classic",
    table: "1",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/Egame/22004.png",
    name: "Plinko",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-004",
    cateogry: "SPRIBE",
    type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/Egame/22008.png",
    name: "Mini Roulette",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-008",
     cateogry: "SPRIBE",
   type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Egame/22005.png",
    name: "Mines",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-005",
     cateogry: "SPRIBE",
   type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Egame/22006.png",
    name: "Spribe Hilo",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-006",
     cateogry: "SPRIBE",
   type: "HOT",
    isPopular: true,
  },
  
 {
    img: "../assets/images/Egame/22001.png",
    name: "Aviator",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
    cateogry: "SPRIBE",
   type: "HOT",
    isPopular: true,
  },


      //----------------------BNG GAME START----------------//
         {
        id:1,
        img: '../assets/images/BNG/BNG087.webp',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

     {
        id:2,
        img: '../assets/images/BNG/BNG074.webp',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: '../assets/images/BNG/BNG075.webp',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: '../assets/images/BNG/BNG071.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

        {
        id:2,
        img: '../assets/images/BNG/BNG098.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
    {
        id:2,
        img: '../assets/images/BNG/BNG084.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

{
        id:2,
        img: '../assets/images/BNG/BNG105.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

{
        id:2,
        img: '../assets/images/BNG/BNG086.webp',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: '../assets/images/BNG/BNG066.webp',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: '../assets/images/BNG/BNG107.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

      {
        id:2,
        img: '../assets/images/BNG/BNG094.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: '../assets/images/BNG/BNG092.webp',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG068.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG093.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG115.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG070.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
             {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG055.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
              {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG032.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
               {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG126.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG082.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG175.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG174.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG173.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG172.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG171.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG170.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG169.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG168.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG167.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG166.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG165.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG164.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG163.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG162.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG161.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG160.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG159.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG158.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG157.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG156.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG155.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG154.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG153.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG152.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG151.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG150.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG149.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG148.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG147.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG146.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG145.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG144.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG143.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG142.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG141.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG140.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG139.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG138.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG137.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG136.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG135.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG134.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG133.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG132.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG131.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG130.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG129.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG128.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG127.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG126.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG125.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG124.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG123.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG122.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG121.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG120.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG119.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG118.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG117.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG116.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG115.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG114.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG113.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG112.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG111.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG110.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG109.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG108.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG107.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG106.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG105.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG104.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG103.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG102.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG101.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG096.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG095.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG090.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG089.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG088.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG085.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG083.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG080.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG079.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG078.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG077.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG076.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG073.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG072.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG067.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG064.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG063.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG062.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG061.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG060.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG059.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG057.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG056.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG054.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG051.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG049.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG047.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG042.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG041.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG040.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG039.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG038.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG036.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG035.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG033.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG029.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG028.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG027.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG026.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG025.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG023.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG021.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
     {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG019.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG018.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG016.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG015.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG013.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG011.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG010.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG009.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG008.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG007.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG004.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG002.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

      //bng game end----------------//
    

      
// -------------------CRASH SPRIBE START-----------------];



{
  img: "../assets/images/crash/spribe/SPRIBE-EGAME-001.png",
  name: "Aviator",
  cateogry:"SPRIBE",
  type:"CRASH",
  platForm: "SPRIBE",
  gameType: "EGAME",
  casinoType: "SPRIBE-EGAME-001",
},

// -------------------CRASH SPRIBE END-----------------];


// -------------------CRASH JILI START-----------------];
{
  img: "../assets/images/crash/jili/JILI-TABLE-047.png",
  name: "Crash Bonus",
  cateogry:"JILI",
  type:"CRASH",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-047",
},
{
  img: "../assets/images/crash/jili/JILI-TABLE-058.png",
  name: "Crash Cricket",
  cateogry:"JILI",
  type:"CRASH",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-058",
},
{
  img: "../assets/images/crash/jili/JILI-TABLE-030.png",
  name: "Go Rush",
  cateogry:"JILI",
  type:"CRASH",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-030",
},
{
  img: "../assets/images/crash/jili/JILI-TABLE-035.png",
  name: "Limbo",
  cateogry:"JILI",
  type:"CRASH",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-035",
},
{
  img: "../assets/images/crash/jili/JILI-TABLE-055.png",
  name: "Crash Goal",
  cateogry:"JILI",
  type:"CRASH",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-055",
},
// -------------------CRASH JILI END-----------------];

// -------------------CRASH PP START-----------------];

{
  img: "../assets/images/crash/pp/PP-EGAME-008.png",
  name: "High Flyer ",
  cateogry:"PP",
  type:"CRASH",
  platForm: "PP",
  gameType: "EGAME",
  casinoType: "PP-EGAME-008",
},
{
  img: "../assets/images/crash/pp/PP-EGAME-001.png",
  name: "Spaceman",
  cateogry:"PP",
  type:"CRASH",
  platForm: "PP",
  gameType: "EGAME",
  casinoType: "PP-EGAME-001",
},
{
  img: "../assets/images/crash/pp/PP-EGAME-009.png",
  name: "Big Bass Crash",
  cateogry:"PP",
  type:"CRASH",
  platForm: "PP",
  gameType: "EGAME",
  casinoType: "PP-EGAME-009",
},
// -------------------CRASH PP END-----------------];

// -------------------CRASH KINGMAKER START-----------------];

{
  img: "../assets/images/crash/kingmaker/KM-TABLE-041.png",
  name: "Cash Rocket",
  cateogry:"KINGMAKER",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-041",
},
{
  img: "../assets/images/crash/kingmaker/KM-TABLE-069.png",
  name: "Elite Aviator Club",
  cateogry:"KINGMAKER",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-069",
},
{
  img: "../assets/images/crash/kingmaker/KM-TABLE-070.png",
  name: "Interstellar Run",
  cateogry:"KINGMAKER",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-070",
},
{
  img: "../assets/images/crash/kingmaker/KM-TABLE-075.png",
  name: "Iron Dome",
  cateogry:"KINGMAKER",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-075",
},
{
  img: "../assets/images/crash/kingmaker/KM-TABLE-076.png",
  name: "TOON CRASH",
  cateogry:"KINGMAKER",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
// -------------------CRASH KINGMAKER END-----------------];
// -------------------CRASH GEMINI START-----------------];
{
  img: "../assets/images/crash/gemini/GM0052.webp",
  name: "TOON CRASH",
  cateogry:"GEMINI",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/gemini/GM0033.webp",
  name: "TOON CRASH",
  cateogry:"GEMINI",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/gemini/GM0027.webp",
  name: "TOON CRASH",
  cateogry:"GEMINI",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/gemini/GM0020.webp",
  name: "TOON CRASH",
  cateogry:"GEMINI",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/gemini/GM0015.webp",
  name: "TOON CRASH",
  cateogry:"GEMINI",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
// -------------------CRASH GEMINI END-----------------];


// -------------------CRASH PASCAL START-----------------];
{
  img: "../assets/images/crash/pascal/PAS092.webp",
  name: "TOON CRASH",
  cateogry:"PASCAL",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/pascal/PAS067.webp",
  name: "TOON CRASH",
  cateogry:"PASCAL",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/pascal/PAS014.webp",
  name: "TOON CRASH",
  cateogry:"PASCAL",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/pascal/PAS013.webp",
  name: "TOON CRASH",
  cateogry:"PASCAL",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},

// -------------------CRASH PASCAL END-----------------];

// -------------------CRASH EG START-----------------];
{
  img: "../assets/images/crash/easygaming/EZG021.webp",
  name: "TOON CRASH",
  cateogry:"EG",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},



// -------------------CRASH EG END-----------------];
// -------------------CRASH MG START-----------------];
{
  img: "../assets/images/crash/mg/MG0436.webp",
  name: "TOON CRASH",
  cateogry:"MG",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/mg/MG0508.webp",
  name: "TOON CRASH",
  cateogry:"MG",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},



// -------------------CRASH MG END-----------------];
// -------------------CRASH MG START-----------------];
{
  img: "../assets/images/crash/SMARTSOFT/SS0059.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/SMARTSOFT/SS0054.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/SMARTSOFT/SS0012.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},

{
  img: "../assets/images/crash/SMARTSOFT/SS0011.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},

{
  img: "../assets/images/crash/SMARTSOFT/SS0007.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},

{
  img: "../assets/images/crash/SMARTSOFT/SS0002.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/SMARTSOFT/SS0014.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
// -------------------CRASH MG END-----------------];


// -------------------CRASH BGAMING START-----------------];
{
  img: "../assets/images/crash/BGAMING/BGA163.webp",
  name: "TOON CRASH",
  cateogry:"BGAMING",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/BGAMING/BGA077.webp",
  name: "TOON CRASH",
  cateogry:"BGAMING",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},

{
  img: "../assets/images/crash/BGAMING/BGA015.webp",
  name: "TOON CRASH",
  cateogry:"BGAMING",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/BGAMING/BGA014.webp",
  name: "TOON CRASH",
  cateogry:"BGAMING",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/BGAMING/BGA013.webp",
  name: "TOON CRASH",
  cateogry:"BGAMING",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},

// -------------------CRASH BGAMING END-----------------];


// -------------------CRASH YL START-----------------];
{
  img: "../assets/images/crash/YL/YL0023.webp",
  name: "TOON CRASH",
  cateogry:"BGAMING",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},


// -------------------CRASH YL END-----------------];

//----------BGAMING--------------------

{
        id:1,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA165.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      // {
      //   id:2,
      //   img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA163.png',
      //   name: "Infinity Pull",
      //   cateogry: "BGAMING",
      //   type: "ROYAL",
      //   gameTypeCheck: "platForm",
      //   platForm: "JDB",
      //   gameType: "SLOT",
      //   casinoType: "JDB-SLOT-041",
      // },

       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA162.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA161.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA160.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA159.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA158.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA155.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA154.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA153.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA152.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA151.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA150.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA149.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA148.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA146.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA145.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA144.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA143.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA140.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA138.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA135.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA134.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA125.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA124.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA123.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA122.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA116.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA115.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA114.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA113.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA112.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA111.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA110.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA109.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA108.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA106.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA105.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA104.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA104.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA103.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA102.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA101.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA100.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA099.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA098.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA097.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA096.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA095.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA094.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA093.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA092.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA091.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA090.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA089.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA088.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA087.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA086.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA085.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA084.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA083.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA082.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA081.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA080.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA079.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA078.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA077.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA076.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA075.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA074.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA073.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA072.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA071.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA070.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA069.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA069.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA068.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA067.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA066.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA065.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA064.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA063.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA062.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA061.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA060.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA059.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA058.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA057.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA056.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA055.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA054.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA053.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA052.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA051.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA050.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA049.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA048.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA047.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA046.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA045.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA044.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA043.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA042.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA041.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA040.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA039.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA038.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA037.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA036.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA035.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
    {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA034.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },    {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA033.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA032.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA031.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA030.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA029.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA028.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA027.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA026.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA025.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA024.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA023.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA022.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA021.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA020.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA019.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA018.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA017.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA016.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA015.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA014.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA013.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA012.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA011.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA010.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA009.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA008.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA007.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA006.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA005.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA004.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA003.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA002.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
//--------------BGAMING----------------//
//--------------EVOPLAY----------------//

  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0229.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0228.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0227.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0226.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0225.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0224.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0223.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0222.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0221.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0220.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0219.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0218.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0217.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0216.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0215.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0214.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0213.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0212.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0211.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0210.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0209.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0208.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0207.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0206.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0205.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0204.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0203.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0202.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0201.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0200.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0199.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0198.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0197.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0196.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0195.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0194.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0193.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0192.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0191.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0190.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0189.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0188.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0187.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0186.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0185.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0184.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0183.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0182.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0181.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0180.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      }, {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0179.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      }, {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0178.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0177.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0176.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0175.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0174.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0173.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0172.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0171.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0170.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0169.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0168.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0167.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0166.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0165.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0164.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0163.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0162.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0161.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0160.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0159.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0158.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0157.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0156.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0155.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0154.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0153.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0152.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0151.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0150.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0149.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0148.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0147.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0146.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0145.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0144.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0143.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0142.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0141.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0140.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0139.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0138.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0137.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0136.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0135.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0134.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0133.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0132.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0131.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0130.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0129.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0128.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0127.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0126.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0125.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0124.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0123.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0122.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0121.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0120.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0119.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0118.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0117.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0116.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0115.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0114.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0113.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0112.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0111.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0110.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0109.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0108.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0107.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0106.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0105.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0104.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0103.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0102.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0101.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0100.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0099.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0098.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0097.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0096.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0095.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0094.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0093.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0092.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0091.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0090.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0089.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0088.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0087.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0086.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0085.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0084.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0083.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0082.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0081.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0080.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0079.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0078.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0077.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0076.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0075.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0074.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0073.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0072.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0071.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0070.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0069.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0068.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0067.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0066.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0065.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0064.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0063.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0062.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0061.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0060.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
    {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0059.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0058.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0057.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0056.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0055.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0054.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0053.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0052.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0051.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0050.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0049.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0048.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0047.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0046.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0045.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0044.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0043.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0042.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0041.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0040.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0039.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0038.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0037.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0036.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0035.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0034.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0033.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0032.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0031.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0030.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0029.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0028.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0027.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0026.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0025.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0024.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0023.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0022.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0021.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0020.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0019.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0018.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0017.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0016.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0015.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0014.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0013.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0012.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0011.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0010.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0007.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0006.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0004.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0003.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           
//--------------EVOPLAY----------------//
//--------------SMARTSOFT----------------//
     {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0059.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
             {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0060.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0054.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0059.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0049.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0048.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0047.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0046.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0045.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0044.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0040.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0034.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0029.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0028.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0027.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0026.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0025.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0023.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0018.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0017.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0016.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0015.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0014.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0012.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0011.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0009.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0008.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0007.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0004.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0002.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
//--------------SMARTSOFT----------------//
 {
    img: "../assets/images/CardGames/EVOLUTION-LIVE-012.webp",
    name: "Infinite Black Jack",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-012",
    cateogry: "EVO",
   type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/CardGames/EVOLUTION-LIVE-181.webp",
    name: "Lightning Black Jack",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-181",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
//    {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-037.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/freebet.webp",
//     name: "Infinite Free Bet Blackjack",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-037",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//   },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-016.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/powerblackjack.webp",
//     name: "Power Blackjack",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-016",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//   },
  
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-173.jpg",
//     thumbnail:"",
//     name: "Speed VIP Blackjack H",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-173",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//   },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-412.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/infinitebetstackerblackjack.webp",
//     name: "Infinite Bet Stacker Blackjack",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-412",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-413.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/easyblackjack.webp",
//     name: "Easy Blackjack",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-413",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-042.jpg",
//     thumbnail:"",
//     name: "Blackjack Party",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-042",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-215.jpg",
//     thumbnail:"",
//     name: "Salon Privé Blackjack A",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-215",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//   },

  {
    img: "../assets/images/CardGames/EVOLUTION-LIVE-208.webp",
    name: "Lightning BlackJack First Person",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-208",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },

// {
//     img: "../assets/images/Roulette/ROULETTE-7.webp",
//     name: "Amercian Roulette Live",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-020",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },

//   {
//       img: "../assets/images/live/evo/EVOLUTION-LIVE-040.jpg",
//       thumbnail:"https://bshots.egcvi.com/thumbnail/lightning_roulette.webp",
//       name: "Lightning Roulette",
//       platForm: "EVOLUTION",
//       gameType: "LIVE",
//       casinoType: "EVOLUTION-LIVE-040",
//       cateogry: "EVO",
//       type: "GAME-SHOWS",
//       isPopular: true,
//     },


 {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-180.png",
    name: "Immersive Roulette",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-180",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-043.jpg",
//     name: "Double Ball Roulette",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-043",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//   },

// {
//     img: "../assets/images/Roulette/ROULETTE-3.webp",
//     name: "Speed Roulette",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-078",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
//   {
//     img: "../assets/images/Roulette/ROULETTE-5.webp",
//     name: "Instant Roulette",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-008",
//     cateogry: "EVO",
// type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-212.jpg",
//     name: "Speed Auto Roulette",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-212",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-257.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/reddoorroulette.webp",
//     name: "Red Door Roulette",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-257",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-228.jpg",
//     thumbnail:"",
//     name: "Gold Vault Roulette",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-228",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-081.png",
    name: "Salon Privé Roulette",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-081",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },

// {
//     img: "../assets/images/Roulette/ROULETTE-1.webp",
//     name: "Roulette Live",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-001",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/Roulette/ROULETTE-4.webp",
//     name: "Roulette VIP",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-079",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },

 {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-017.png",
    name: "Classic Live Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-017",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },


// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-256.jpg",
//     name: "XXXtreme lightning Baccarat",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-256",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/Baccarat/BACCARAT-2.webp",
//     name: "Baccarat no commission",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-038",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
   {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-036.png",
    name: "Baccarat Squeeze",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-036",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-041.png",
    name: "Control Squeeze Baccara",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-041",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-182.png",
    name: "Peek Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-182",
    cateogry: "EVO",
type: "GAME-SHOWS",
  },

// {
//     img: "../assets/images/Baccarat/BACCARAT-1.webp",
//     name: "Golden Wealth Baccarat",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-179",
//     cateogry: "EVO",
// type: "GAME-SHOWS",
//     isPopular: true,
//   },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-172.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/bacbo.webp",
//     name: "Bac Bo",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-172",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

//  {
//     img: "../assets/images/TraditionalGames/TRADINATIONAL-4.webp",
//     name: "Dragon Tiger",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-004",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
  // {
  //   img: "../assets/images/TraditionalGames/TRADINATIONAL-2.webp",
  //   name: "Fan Tan",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-178",
  //   cateogry: "EVO",
  //  type: "GAME-SHOWS",
  //   isPopular: true,
  // },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-410.jpg",
//     name: "Always 8 Baccarat",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-410",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//  {
//     img: "../assets/images/Baccarat/EVOLUTION-LIVE-245.png",
//     name: "Prosperity Tree Baccarat ",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-245",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-398.jpg",
//     name: "Super speed Baccarat ",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-398",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-015.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/poker_holdem.webp",
//     name: "Casino Hold'em ",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-015",
//     cateogry: "EVO",
//   type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-024.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/poker_csp.webp",
//     name: "Caribbean Stud Poker",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-024",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-027.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/poker_thb.webp",
//     name: "Texas Hold'em Bonus Poker",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-027",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-021.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/poker_dhp.webp",
//     name: "2 Hand Casino Hold'em",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-021",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-026.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/poker_teenpatti.webp",
//     name: "Teen Patti",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-026",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
  // {
  //   img: "../assets/images/TraditionalGames/TRADINATIONAL-1.webp",
  //   name: "Super Andhar Bahar",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-204",
  //   cateogry: "EVO",
  //   type: "GAME-SHOWS",
  //   isPopular: true,
  // },

// {
//     img: "../assets/images/Dice/DICE-3.webp",
//     name: "Craps Live",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-003",
//     cateogry: "EVO",
//   type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/Dice/DICE-2.webp",
//     name: "Super Sic Bo",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-005",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-011.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/lightning_dice.webp",
//     name: "Lightning Dice",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-011",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-044.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/topdice.webp",
//     name: "Football Studio Dice",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-044",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-006.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/crazytime.webp",
//     name: "Crazy Time",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-006",
//     cateogry: "EVO",
//  type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-169.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/imperialquest.webp",
//     name: "Imperial Quest",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-169",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-007.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/monopoly.webp",
//     name: "Monopoly Live",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-007",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-025.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/dealnodeallivespins.webp",
//     name: "Deal or No Deal",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-025",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-035.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/dreamcatcher.webp",
//     name: "Dream Catcher",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-035",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-010.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/megaball.webp",
//     name: "Mega Ball",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-010",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-183.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/funkytime.webp",
//     name: "Funky Time",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-183",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-014.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/crazycoinflip.webp",
//     name: "Crazy Coin Flip",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-014",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-409.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/crazyballs.webp",
//     name: "Crazy Balls",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-409",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-018.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/monopolybigballer.webp",
//     name: "MONOPOLY Big Baller",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-018",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
  
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-261.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/crazypachinko.webp",
//     name: "Crazy Pachinko",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-261",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-168.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/extrachilliepicspins.webp",
//     name: "Extra Chilli Epic Spins",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-168",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-175.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/cashorcrash.webp",
//     name: "Cash or Crash",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-175",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
  
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-045.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/topcard.webp",
//     name: "Football Studio",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-045",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-369.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/lightningstorm.webp",
//     name: "Lightning Storm",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-369",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-435.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/supercolorgame.webp",
//     name: "Super Color Game",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-435",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-434.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/marblerace.webp",
//     name: "Marble Race",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-434",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-363.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/balloonrace.webp",
//     name: "Balloon Race",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-363",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-1.webp",
  //   name: "XXXtreme Lightning roulette",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-205",
  //   cateogry: "EVO",
  //   type: "GAME-SHOWS",
  //   isPopular: true,
  // },
 
  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-4.webp",
  //   name: "Dead or Alive Saloon",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-176",
  //   cateogry: "EVO",
  //  type: "GAME-SHOWS",
  //   isPopular: true,
  // },
{
    img: "../assets/images/Dice/EVOLUTION-LIVE-031.png",
    name: "First Person Craps",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-031",
    cateogry: "EVO",
  type: "GAME-SHOWS",
  },

 {
    img: "../assets/images/TraditionalGames/EVOLUTION-LIVE-033.png",
    name: "First Person Dragon Tiger",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-033",
    cateogry: "EVO",
   type: "GAME-SHOWS",
  },

 {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-046.png",
    name: "First Person Golden Wealth Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-046",
    cateogry: "EVO",
   type: "GAME-SHOWS",
  },
// {
//     img: "../assets/images/Dice/DICE-1.webp",
//     name: "Bac Bo Live",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-172",
//     cateogry: "EVO",
//   type: "GAME-SHOWS",
//     isPopular: true,
//   },
  
  // {
  //   img: "../assets/images/Dice/EVOLUTION-LIVE-259.png",
  //   name: "First Person Super Sic Bo",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-259",
  //   cateogry: "EVO",
  // type: "GAME-SHOWS",
  //   isPopular: true,
  // },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-225.jpg",
//     name: "First Person Deal or No Deal",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-225",
//     cateogry: "EVO",
//   type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/Baccarat/EVOLUTION-LIVE-244.png",
//     name: "First Person Prosperity Tree Baccarat",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-244",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-364.jpg",
//     name: "First Person HiLo",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-364",
//     cateogry: "EVO",
//   type: "GAME-SHOWS",
//     isPopular: true,
//   },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-118.jpg",
//     name: "Blackjack Diamond VIP",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-118",
//     cateogry: "EVO",
//   type: "GAME-SHOWS",
//     isPopular: true,
//   },
//    {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-117.jpg",
//     name: "Blackjack Platinum VIP",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-117",
//     cateogry: "EVO",
//   type: "GAME-SHOWS",
//     isPopular: true,
//   },

//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-449.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/icefishing.webp",
//     name: "Ice Fishing",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-449",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },



  
//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-114.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/crazytime.webp",
//     name: "Crazy Time A",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-114",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },


// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-436.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/fireballroulette.webp",
//     name: "Fireball Roulette",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-436",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-376.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/lightningball.webp",
//     name: "Lightning Ball",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-376",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },


//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-431.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/war.webp",
//     name: "War",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-431",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-176.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/deadoralivesaloon.webp",
//     name: "Dead or Alive: Saloon",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-176",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
  
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-246.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/gonzotreasuremap.webp",
//     name: "Gonzo's Treasure Map",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-246",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },



//    {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-230.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/bacbo.webp",
//     name: "Emperor Bac Bo",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-230",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-178.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/fantan.webp",
//     name: "Fan Tan",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-178",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-414.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/goldenwealth_baccarat.webp",
//     name: "Emperor Golden Wealth Baccarat",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-414",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-150.jpg",
//     thumbnail:"",
//     name: "Emperor Speed Baccarat A",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-150",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-147.jpg",
//     thumbnail:"",
//     name: "Emperor Speed Baccarat B",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-147",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-153.jpg",
//     thumbnail:"",
//     name: "Emperor Speed Baccarat C",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-153",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-210.jpg",
//     thumbnail:"",
//     name: "Emperor Speed Baccarat D",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-210",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-229.jpg",
//     thumbnail:"",
//     name: "Hindi Speed Baccarat A",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-229",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-277.jpg",
//     thumbnail:"",
//     name: "Hindi Speed Baccarat B",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-277",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
  
  
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-114.png",
    name: "Crazy Time",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-114",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  

  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-2.webp",
  //   name: "Cash or Crash",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-175",
  //   cateogry: "EVO",
  //   type: "GAME-SHOWS",
  //   isPopular: false,
  // },
  
  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-8.webp",
  //   name: "Lightning Fever",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-133",
  //   cateogry: "EVO",
  //   type: "GAME-SHOWS",
  //   isPopular: true,
  // },

  
  // {
  //   img: "../assets/images/game-shows/EVOLUTION-LIVE-114.png",
  //   name: "Crazy Time",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-114",
  //   cateogry: "EVO",
  //   type: "GAME-SHOWS",

  // },

  
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-291.jpg",
//     thumbnail:"",
//     name: "Stock Market",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-291",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
  
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-023.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-023",
    cateogry: "EVO",
   type: "GAME-SHOWS",
  },
  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-15.webp",
  //   name: "Deal or Nodeal",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-025",
  //   cateogry: "EVO",
  //   type: "GAME-SHOWS",
  //   isPopular: true,
  // },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-023.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-023",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  // {
  //   img: "../assets/images/game-shows/EVOLUTION-LIVE-246.png",
  //   name: "Gonzo's Treasure Map",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-246",
  //   cateogry: "EVO",
  //   type: "GAME-SHOWS",
  //   isPopular: true,
  // },

{
    img: "../assets/images/game-shows/EVOLUTION-LIVE-034.png",
    name: "First Person Mega Ball",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-034",
    cateogry: "EVO",
   type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-028.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-028",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-034.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-034",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-035.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-035",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-044.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-044",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-045.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-045",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-369.png",
    name: "lighting storm",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-369",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },

  {
    img: "../assets/images/game-shows/PP-LIVE-062.png",
    name: "Mega Sicbo",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-062",
    cateogry: "PP",
    type: "GAME-SHOWS",
  },


  
 
  





  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-19.webp",
  //   name: "Spin and Win Wild B X2",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-088",
  //   cateogry: "PT",
  //   type: "GAME-SHOWS",
  //   isPopular: true,
  // },
  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-20.webp",
  //   name: "The Greatest Cards Show",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-086",
  //   cateogry: "PT",
  //   type: "GAME-SHOWS",
  //   isPopular: true,
  // },
  
  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-22.webp",
  //   name: "Mega Fire Blaze Roulette",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-028",
  //   cateogry: "PT",
  //   type: "GAME-SHOWS",
  //   isPopular: true,
  // },


 
  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-26.webp",
  //   name: "Power Roulette",
  //   platForm: "PP",
  //   gameType: "LIVE",
  //   casinoType: "PP-LIVE-055",
  //   cateogry: "PP",
  //   type: "GAME-SHOWS",
  //   isPopular: true,
  // },


  
  
  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-29.webp",
  //   name: "Bet on Dragon Tiger",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-030",
  //   cateogry: "PT",
  //   type: "GAME-SHOWS",
  //   isPopular: true,
  // },
  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-30.webp",
  //   name: "Hi-lo Club",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-014",
  //   cateogry: "PT",
  //   type: "GAME-SHOWS",
  //   isPopular: true,
  // },


  
  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-32.webp",
  //   name: "Italian Cashback Blackjack",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-031",
  //   cateogry: "PT",
  //   type: "GAME-SHOWS",
  //   isPopular: false,
  // },
  // {
  //   img: "../assets/images/game-shows/PT-LIVE-116.webp",
  //   name: "K-Pop Roulette Live",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-116",
  //   cateogry: "PT",
  //   type: "GAME-SHOWS",
  //   isPopular: true,
  // },

  // {
  //   img: "../assets/images/game-shows/PT-LIVE-090.png",
  //   name: "Italian Cashback Blackjack",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-090",
  //   cateogry: "PT",
  //   type: "GAME-SHOWS",
  // },
  // {
  //   img: "../assets/images/game-shows/PT-LIVE-090.png",
  //   name: "Italian Cashback Blackjack",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-090",
  //   cateogry: "PT",
  //   type: "GAME-SHOWS",
  // },
  {
    img: "../assets/images/game-shows/PT-LIVE-108.png",
    name: "Italian Cashback Blackjack",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-108",
    cateogry: "PT",
    type: "GAME-SHOWS",
  },



  

  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-31.webp",
  //   name: "Quantum BlackJack Plus",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-029",
  //   cateogry: "PT",
  //   type: "GAME-SHOWS",
  // },
  // {
  //   img: "../assets/images/Baccarat/HOTROAD-LIVE-001.webp",
  //   name: "HOTROAD-LIVE-001",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-001",
  //   cateogry: "HOTROAD",
  //   type: "BACCARAT",
  //   table: "1",
  //   isPopular: true,
  // },
  // {
  //   img: "../assets/images/Baccarat/HOTROAD-LIVE-001.webp",
  //   name: "HOTROAD-LIVE-001",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-001",
  //   cateogry: "HOTROAD",
  //   type: "BACCARAT",
  //   table: "2",
  //   isPopular: true,
  // },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-001.webp",
    name: "HOTROAD-LIVE-001",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-001",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "3",
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-001.webp",
    name: "HOTROAD-LIVE-001",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-001",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "4",
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-001.webp",
    name: "HOTROAD-LIVE-001",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-001",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "5",
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-001.webp",
    name: "HOTROAD-LIVE-001",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-001",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "6",
  },
  // {
  //   img: "../assets/images/Baccarat/HOTROAD-LIVE-007.webp",
  //   name: "HOTROAD-LIVE-007",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-007",
  //   cateogry: "HOTROAD",
  //   type: "BACCARAT",
  //   table: "6001",
  //   isPopular: true,
  // },
  // {
  //   img: "../assets/images/Baccarat/HOTROAD-LIVE-007.webp",
  //   name: "HOTROAD-LIVE-007",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-007",
  //   cateogry: "HOTROAD",
  //   type: "BACCARAT",
  //   table: "6002",
  //   isPopular: true,
  // },

  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-007.webp",
    name: "HOTROAD-LIVE-007",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-007",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "6003",
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-007.webp",
    name: "HOTROAD-LIVE-007",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-007",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "6004",
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-007.webp",
    name: "HOTROAD-LIVE-007",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-007",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "6005",
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-007.webp",
    name: "HOTROAD-LIVE-007",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-007",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "6006",
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-1.webp",
    name: "Golden Wealth Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-179",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-2.webp",
    name: "Baccarat no commission",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-038",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-3.webp",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-159",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-134.png",
    name: "Baccarat no commission",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-134",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-255.png",
    name: "Golden Wealth Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-255",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-5.webp",
    name: "Lightning Baccarat First Person",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-255",
    cateogry: "EVO",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-210.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-210",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-245.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-245",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },


 

  {
    img: "../assets/images/Baccarat/BACCARAT-7.webp",
    name: "Baccarat Classic",
    table: "1",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-8.webp",
    name: "Baccarat Classic",
    table: "2",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-9.webp",
    name: "Baccarat Classic",
    table: "3",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-10.webp",
    name: "Baccarat Classic",
    table: "4",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-11.webp",
    name: "Baccarat Classic",
    table: "5",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-12.webp",
    name: "Baccarat Classic",
    table: "6",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "BACCARAT",
    isPopular: true,
  },
   //LIVE SEXY START




//LIVE SEXY END

  {
    img: "../assets/images/Baccarat/PT-LIVE-109.png",
    name: "Baccarat Classic",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-109",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/PT-LIVE-001.png",
    name: "Baccarat Classic",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-001",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/PT-LIVE-005.png",
    name: "Baccarat Classic",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-005",
    cateogry: "PT",
    type: "BACCARAT",
  },
  //LIVE PT START


 {
    img: "../assets/images/live/pt/PT-LIVE-147.webp",
    name: "Super Card Blackjack Live",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-147",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },
 {
    img: "../assets/images/live/pt/PT-LIVE-145.webp",
    name: "Speed Baccarat 2",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-145",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },
 {
    img: "../assets/images/live/pt/PT-LIVE-145.webp",
    name: "Speed Baccarat 1",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-144",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },
 {
    img: "../assets/images/live/pt/PT-LIVE-146.webp",
    name: "Super Speed Baccarat",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-146",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },

{
    img: "../assets/images/live/pt/PT-LIVE-143.webp",
    name: "Quantum Baccarat Live",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-143",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },


{
    img: "../assets/images/live/pt/PT-LIVE-096.webp",
    name: "Speed Baccarat Korean 2",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-096",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/PP-LIVE-001.png",
    name: "Baccarat Classic",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-001",
    cateogry: "PP",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/PP-LIVE-010.png",
    name: "Baccarat Classic",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-010",
    cateogry: "PP",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-24.webp",
    name: "Speed Baccarat 1",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-013",
    cateogry: "PP",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-25.webp",
    name: "Super 8 Baccarat",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-045",
    cateogry: "PP",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/PP-LIVE-050.png",
    name: "Super 8 Baccarat",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-050",
    cateogry: "PP",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/PP-LIVE-051.png",
    name: "Super 8 Baccarat",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-051",
    cateogry: "PP",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/PP-LIVE-052.png",
    name: "Super 8 Baccarat",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-052",
    cateogry: "PP",
    type: "BACCARAT",
  },
  // {
  //   img: "../assets/images/Baccarat/EVOLUTION-LIVE-244.png",
  //   name: "Speed Baccarat",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-244",
  //   cateogry: "EVO",
  //   type: "BACCARAT",
  //   isPopular: true,
  // },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-256.png",
    name: "Golden Wealth Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-256",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-182.png",
    name: "Golden Wealth Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-182",
    cateogry: "EVO",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-135.png",
    name: "Baccarat no commission",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-135",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-136.png",
    name: "Baccarat no commission",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-136",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-160.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-160",
    cateogry: "EVO",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-161.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-161",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-253.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-253",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-254.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-254",
    cateogry: "EVO",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-153.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-153",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-017.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-017",
    cateogry: "EVO",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-036.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-036",
    cateogry: "EVO",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-041.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-041",
    cateogry: "EVO",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-046.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-046",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  // {
  //   img: "../assets/images/Baccarat/BACCARAT-17.webp",
  //   name: "Baccarat Classic",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-001",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-18.webp",
  //   name: "Baccarat Classic",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-001",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-19.webp",
  //   name: "Baccarat Classic",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-001",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-20.webp",
  //   name: "Baccarat Classic",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-001",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-21.webp",
  //   name: "Baccarat Classic",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-001",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-22.webp",
  //   name: "Baccarat Classic",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-001",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },

  // {
  //   img: "../assets/images/Baccarat/BACCARAT-26.webp",
  //   name: "Speed Baccarat",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-002",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-27.webp",
  //   name: "Baccarat Insurance",
  //   platForm: "SEXY",
  //   gameType: "LIVE",
  //   casinoType: "MX-LIVE-002",
  //   cateogry: "SEXY",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-28.webp",
  //   name: "Baccarat Insurance",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-003",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // Baccarat End

  // Roulette Start
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
  //   name: "HOTROAD-LIVE-002",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-002",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "1001",
  //   isPopular: true,
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
  //   name: "HOTROAD-LIVE-002",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-002",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "1002",
  //   isPopular: true,
  // },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
    name: "HOTROAD-LIVE-002",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-002",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "1003",
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
    name: "HOTROAD-LIVE-002",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-002",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "1004",
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
    name: "HOTROAD-LIVE-002",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-002",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "1005",
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
    name: "HOTROAD-LIVE-002",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-002",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "1006",
  },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
  //   name: "HOTROAD-LIVE-004",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-004",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "5001",
  //   isPopular: true,
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
  //   name: "HOTROAD-LIVE-004",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-004",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "5002",
  //   isPopular: true,
  // },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
    name: "HOTROAD-LIVE-004",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-004",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "5003",
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
    name: "HOTROAD-LIVE-004",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-004",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "5004",
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
    name: "HOTROAD-LIVE-004",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-004",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "5005",
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
    name: "HOTROAD-LIVE-004",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-004",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "5006",
  },
  {
    img: "../assets/images/Roulette/ROULETTE-1.webp",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-001",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-2.webp",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-080",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-3.webp",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-078",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-4.webp",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-079",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-5.webp",
    name: "Instant Roulette",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-008",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-6.webp",
    name: "Roulette First Person",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-013",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-7.webp",
    name: "Amercian Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-020",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },


  {
    img: "../assets/images/Roulette/ROULETTE-9.webp",
    name: "Roulette",
    table: "71",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-009",
    cateogry: "SEXY",
    type: "ROULETTE",
    isPopular: true,
  },

  {
    img: "../assets/images/live/sexy/MX-LIVE-009.webp",
    name: "Roulette",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-009",
    cateogry: "SEXY",
    type: "ROULETTE",
    isPopular: true,
  },


  {
    img: "../assets/images/Roulette/ROULETTE-10.webp",
    name: "Roulette",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-029",
    cateogry: "PP",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-11.webp",
    name: "Auto Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-026",
    cateogry: "PP",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-12.webp",
    name: "Speed Auto Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-060",
    cateogry: "PP",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/PT-LIVE-102.png",
    name: "Speed Roulette 2",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-067",
    cateogry: "PP",
    type: "ROULETTE",
    isPopular: true,
  },
  // {
  //   img: "../assets/images/Roulette/ROULETTE-13.webp",
  //   name: "Roulette",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-009",
  //   cateogry: "VENUS",
  //   type: "ROULETTE",
  // },
  {
    img: "../assets/images/Roulette/ROULETTE-14.webp",
    name: "Speed Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-027",
    cateogry: "PP",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-15.webp",
    name: "Azure Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-028",
    cateogry: "PP",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/PT-LIVE-100.png",
    name: "Speed Roulette 2",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-100",
    cateogry: "PT",
    type: "ROULETTE",
  },
  {
    img: "../assets/images/Roulette/PT-LIVE-102.png",
    name: "Speed Roulette 2",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PP-LIVE-102",
    cateogry: "PT",
    type: "ROULETTE",
  },

  {
    img: "../assets/images/Roulette/ROULETTE-16.webp",
    name: "American Roulette Live",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-021",
    cateogry: "PT",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-17.webp",
    name: "Deutsches Roulette Live",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-022",
    cateogry: "PT",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-18.webp",
    name: "Roulette Live",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-025",
    cateogry: "PT",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-19.webp",
    name: "Football French Roulette",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-023",
    cateogry: "PT",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-20.webp",
    name: "Football Roulette",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-024",
    cateogry: "PT",
    type: "ROULETTE",
    isPopular: true,
  },
  // {
  //   img: "../assets/images/Roulette/ROULETTE-21.webp",
  //   name: "Spread Bets Roulette",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-027",
  //   cateogry: "PT",
  //   type: "ROULETTE",
  //   isPopular: true,
  // },
  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-170.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-170",
    cateogry: "EVO",
    type: "ROULETTE",
  },
  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-171.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-171",
    cateogry: "EVO",
    type: "ROULETTE",
  },
  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-180.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-180",
    cateogry: "EVO",
    type: "ROULETTE",
  },

  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-257.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-257",
    cateogry: "EVO",
    type: "ROULETTE",
  },

  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-209.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-209",
    cateogry: "EVO",
    type: "ROULETTE",
  },

  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-206.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-206",
    cateogry: "EVO",
    type: "ROULETTE",
  },

  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-081.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-081",
    cateogry: "EVO",
    type: "ROULETTE",
  },

  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
  //   name: "HOTROAD-LIVE-004",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-004",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "5003",
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
  //   name: "HOTROAD-LIVE-004",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-004",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "5004",
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
  //   name: "HOTROAD-LIVE-004",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-004",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "5005",
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
  //   name: "HOTROAD-LIVE-004",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-004",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "5006",
  // },

  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
  //   name: "HOTROAD-LIVE-002",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-002",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "1003",
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
  //   name: "HOTROAD-LIVE-002",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-002",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "1004",
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
  //   name: "HOTROAD-LIVE-002",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-002",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "1005",
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
  //   name: "HOTROAD-LIVE-002",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-002",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "1006",
  // },
  // {
  //   img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
  //   name: "HOTROAD-LIVE-006",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-006",
  //   cateogry: "HOTROAD",
  //   type: "DICE",
  //   table: "4001",
  //   isPopular: true,
  // },
  // {
  //   img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
  //   name: "HOTROAD-LIVE-006",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-006",
  //   cateogry: "HOTROAD",
  //   type: "DICE",
  //   table: "4002",
  //   isPopular: true,
  // },
  {
    img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
    name: "HOTROAD-LIVE-006",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-006",
    cateogry: "HOTROAD",
    type: "DICE",
    table: "4003",
  },
  {
    img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
    name: "HOTROAD-LIVE-006",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-006",
    cateogry: "HOTROAD",
    type: "DICE",
    table: "4004",
  },
  {
    img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
    name: "HOTROAD-LIVE-006",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-006",
    cateogry: "HOTROAD",
    type: "DICE",
    table: "4005",
  },
  {
    img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
    name: "HOTROAD-LIVE-006",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-006",
    cateogry: "HOTROAD",
    type: "DICE",
    table: "4006",
  },
  {
    img: "../assets/images/Dice/DICE-1.webp",
    name: "Bac Bo Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-172",
    cateogry: "EVO",
    type: "DICE",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/DICE-2.webp",
    name: "Super Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-005",
    cateogry: "EVO",
    type: "DICE",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/EVOLUTION-LIVE-259.png",
    name: "First Person Super Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-259",
    cateogry: "EVO",
    type: "DICE",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/EVOLUTION-LIVE-260.png",
    name: "Instant Super Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-260",
    cateogry: "EVO",
    type: "DICE",
    isPopular: true,
  },

  {
    img: "../assets/images/Dice/DICE-3.webp",
    name: "Craps Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-003",
    cateogry: "EVO",
    type: "DICE",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/DICE-4.webp",
    name: "Experor Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-211",
    cateogry: "EVO",
    type: "DICE",
    isPopular: true,
  },

  {
    img: "../assets/images/Dice/DICE-5.webp",
    name: "Extra Sic bo",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-016",
    cateogry: "SEXY",
    type: "DICE",
    table: "131",
    isPopular: true,
  },
  // {
  //   img: "../assets/images/live/sexy/MX-LIVE-014.webp",
  //   name: "Thai Hi Lo",
  //   platForm: "SEXYBCRT",
  //   gameType: "LIVE",
  //   casinoType: "MX-LIVE-014",
  //   cateogry: "SEXY",
  //   type: "DICE",
  //   isPopular: true,
  // },


  {
    img: "../assets/images/Dice/PP-LIVE-079.webp",
    name: "Sic bo",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-079",
    cateogry: "PP",
    type: "DICE",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/PT-LIVE-099.png",
    name: "Speed SicBo",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-099",
    cateogry: "PT",
    type: "DICE",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/EVOLUTION-LIVE-031.png",
    name: "Experor Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-031",
    cateogry: "EVO",
    type: "DICE",
  },
  {
    img: "../assets/images/Dice/EVOLUTION-LIVE-047.png",
    name: "Experor Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-047",
    cateogry: "EVO",
    type: "DICE",
  },

  // {
  //   img: "../assets/images/Dice/DICE-6.webp",
  //   name: "Red Blue Duel",
  //   platForm: "SEXYBCRT",
  //   gameType: "LIVE",
  //   casinoType: "MX-LIVE-010",
  //   cateogry: "SEXY",
  //   type: "DICE",
  // },
  // {
  //   img: "../assets/images/Dice/DICE-7.webp",
  //   name: "Sic Bo",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-007",
  //   cateogry: "VENUS",
  //   type: "DICE",
  // },

  // {
  //   img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
  //   name: "HOTROAD-LIVE-006",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-006",
  //   cateogry: "HOTROAD",
  //   type: "DICE",
  //   table: "4003",
  // },
  // {
  //   img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
  //   name: "HOTROAD-LIVE-006",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-006",
  //   cateogry: "HOTROAD",
  //   type: "DICE",
  //   table: "4004",
  // },
  // {
  //   img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
  //   name: "HOTROAD-LIVE-006",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-006",
  //   cateogry: "HOTROAD",
  //   type: "DICE",
  //   table: "4005",
  // },
  // Tradiotional Start
  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
  //   name: "HOTROAD-LIVE-003",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-003",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "2001",
  //   isPopular: true,
  // },
  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
  //   name: "HOTROAD-LIVE-003",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-003",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "2002",
  //   isPopular: true,
  // },
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
    name: "HOTROAD-LIVE-003",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-003",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "2003",
  },
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
    name: "HOTROAD-LIVE-003",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-003",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "2004",
  },
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
    name: "HOTROAD-LIVE-003",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-003",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "2005",
  },
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
    name: "HOTROAD-LIVE-003",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-003",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "2006",
  },
  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-008.webp",
  //   name: "HOTROAD-LIVE-008",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-008",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "7001",
  //   isPopular: true,
  // },
  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-008.webp",
  //   name: "HOTROAD-LIVE-008",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-008",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "7002",
  //   isPopular: true,
  // },
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-008.webp",
    name: "HOTROAD-LIVE-008",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-008",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "7003",
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-1.webp",
    name: "Super Andhar Bahar",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-204",
    cateogry: "EVO",
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-2.webp",
    name: "Fan Tan",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-178",
    cateogry: "EVO",
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-4.webp",
    name: "Dragon Tiger",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-004",
    cateogry: "EVO",
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-3.webp",
    name: "Dragon Tiger",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-077",
    cateogry: "EVO",
    type: "TRADITIONAL",
    isPopular: true,
  },

  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-5.webp",
    name: "Teen Patti Live",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-026",
    cateogry: "EVO",
    type: "TRADITIONAL",
    isPopular: true,
  },

  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-6.webp",
    name: "Dragon Tiger",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-006",
    cateogry: "SEXY",
    table:'31',
    type: "TRADITIONAL",
    isPopular: true,
  },
  // {
  //   img: "../assets/images/TraditionalGames/TRADINATIONAL-7.webp",
  //   name: "Dragon Tiger",
  //   platForm: "SEXYBCRT",
  //   gameType: "LIVE",
  //   casinoType: "MX-LIVE-006",
  //   cateogry: "SEXY", table:'32',
  //   type: "TRADITIONAL",
  //   isPopular: true,
  // },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-10.webp",
    name: "Dragon Tiger",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-002",
    cateogry: "PT",
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-13.webp",
    name: "Dragon Tiger",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-042",
    cateogry: "PP",
    type: "TRADITIONAL",
    isPopular: true,
  },

  // {
  //   img: "../assets/images/TraditionalGames/TRADINATIONAL-15.webp",
  //   name: "Dragon Tiger",
  //   platForm: "VN",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-006",
  //   cateogry: "VENUS",
  //   type: "TRADITIONAL",
  // },
  // {
  //   img: "../assets/images/TraditionalGames/TRADINATIONAL-16.webp",
  //   name: "Dragon Tiger",
  //   platForm: "VN",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-006",
  //   cateogry: "VENUS",
  //   type: "TRADITIONAL",
  // },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-9.webp",
    name: "Extra Teen Patti",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-012",
    cateogry: "SEXY",
    table:'101',
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-11.webp",
    name: "Andhar Bahar Live",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-004",
    cateogry: "PT",
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/PT-LIVE-087.png",
    name: "Andhar Bahar Live",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-087",
    cateogry: "PT",
    type: "TRADITIONAL",
  },

  // {
  //   img: "../assets/images/TraditionalGames/TRADINATIONAL-14.webp",
  //   name: "Andhar Bahar",
  //   platForm: "PP",
  //   gameType: "LIVE",
  //   casinoType: "PP-LIVE-043",
  //   cateogry: "PP",
  //   type: "TRADITIONAL",
  //   isPopular: true,
  // },

  // {
  //   img: "../assets/images/TraditionalGames/TRADINATIONAL-8.webp",
  //   name: "Teen Patti",
  //   platForm: "SEXYBCRT",
  //   gameType: "LIVE",
  //   casinoType: "MX-LIVE-011",
  //   cateogry: "SEXY",
  //   table:'81',
  //   type: "TRADITIONAL",
  //   isPopular: true,
  // },
  {
    img: "../assets/images/Dice/MX-LIVE-017_SEXY.png",
    name: "xocdia",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-017",
    cateogry: "SEXY",
    table: "151",
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/EVOLUTION-LIVE-033.png",
    name: "Teen Patti Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-033",
    cateogry: "EVO",
    type: "TRADITIONAL",
  },
  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
  //   name: "HOTROAD-LIVE-003",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-003",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "2003",
  // },
  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
  //   name: "HOTROAD-LIVE-003",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-003",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "2004",
  // },
  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
  //   name: "HOTROAD-LIVE-003",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-003",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "2005",
  // },
  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
  //   name: "HOTROAD-LIVE-003",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-003",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "2006",
  // },

  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-008.webp",
  //   name: "HOTROAD-LIVE-008",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-008",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "7003",
  // },
  // {
  //   img: "../assets/images/TraditionalGames/TRADINATIONAL-12.webp",
  //   name: "Teen Patti",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-026",
  //   cateogry: "PT",
  //   type: "TRADITIONAL",
  // },
  // Tradiotional End

  // {
  //   img: "../assets/images/CardGames/EVOLUTION-LIVE-181.webp",
  //   name: "Lightning Black Jack",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-181",
  //   cateogry: "EVOLUTION",
  //   type: "GAME-CARD",
  // },
  {
    img: "../assets/images/CardGames/EVOLUTION-LIVE-208.webp",
    name: "Lightning Black Jack First Person",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-208",
    cateogry: "EVOLUTION",
    type: "GAME-CARD",
  },
  // {
  //   img: "../assets/images/CardGames/EVOLUTION-LIVE-227.png",
  //   name: "Lightning Black Jack First Person",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-227",
  //   cateogry: "EVOLUTION",
  //   type: "GAME-CARD",
  // },
  {
    img: "../assets/images/CardGames/EVOLUTION-LIVE-009.webp",
    name: "Triple Card Poker",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-009",
    cateogry: "EVOLUTION",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/EVOLUTION-LIVE-012.webp",
    name: "Infinite Black Jack",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-012",
    cateogry: "EVOLUTION",
    type: "GAME-CARD",
  },
  // {
  //   img: "../assets/images/CardGames/PT-LIVE-007.png",
  //   name: "Alexandrite Blackjack",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-007",
  //   cateogry: "PT",
  //   type: "GAME-CARD",
  // },
  {
    img: "../assets/images/CardGames/PP-LIVE-040.webp",
    name: "One Blackjack",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-082",
    cateogry: "PP",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/PP-LIVE-041.webp",
    name: "ONE Blackjack 2 - Ruby",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-083",
    cateogry: "PP",
    type: "GAME-CARD",
  },
  // {
  //   img: "../assets/images/CardGames/PT-LIVE-008.webp",
  //   name: "Majority Rules Speed Blackjack",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-008",
  //   cateogry: "PT",
  //   type: "GAME-CARD",
  // },
  {
    img: "../assets/images/CardGames/PT-LIVE-009.png",
    name: "Majority Rules Speed Blackjack",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-009",
    cateogry: "PT",
    type: "GAME-CARD",
  },
  // {
  //   img: "../assets/images/CardGames/EVOLUTION-LIVE-002.webp",
  //   name: "Black Jack A",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-002",
  //   cateogry: "EVOLUTION",
  //   type: "GAME-CARD",
  // },
  // {
  //   img: "../assets/images/CardGames/EVOLUTION-LIVE-015.webp",
  //   name: "Casino Hold'em",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-015",
  //   cateogry: "EVOLUTION",
  //   type: "GAME-CARD",
  // },

  // {
  //   img: "../assets/images/CardGames/EVOLUTION-LIVE-024.webp",
  //   name: "Caribbean Stud Poker",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-024",
  //   cateogry: "EVOLUTION",
  //   type: "GAME-CARD",
  // },

  // {
  //   img: "../assets/images/CardGames/PT-LIVE-007.webp",
  //   name: "All bets Blackjack",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-007",
  //   cateogry: "PT",
  //   type: "GAME-CARD",
  // },

  {
    img: "../assets/images/CardGames/PT-LIVE-010.webp",
    name: "Unlimited Blackjack",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-010",
    cateogry: "PT",
    type: "GAME-CARD",
  },

  {
    img: "../assets/images/CardGames/PT-LIVE-016.webp",
    name: "3 Card Brag",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-016",
    cateogry: "PT",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/PT-LIVE-017.webp",
    name: "Casino Hold AEM",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-017",
    cateogry: "PT",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/PT-LIVE-019.webp",
    name: "Bet on Poker Live",
    platForm: "PLAYTECH",
    gameType: "LIVE",
    casinoType: "PT-PLAYTECH-019",
    cateogry: "PT",
    type: "GAME-CARD",
  },
  // {
  //   img: "../assets/images/CardGames/PT-LIVE-009.webp",
  //   name: "Sette E Mezzo",
  //   platForm: "PLAYTECH",
  //   gameType: "LIVE",
  //   casinoType: "PT-PLAYTECH-009",
  //   cateogry: "PT",
  //   type: "GAME-CARD",
  // },
  // Table Start  (casino Done) -------
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-086.png",
    name: "CHICKEN CROSSY",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-086",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-081.png",
    name: "Egyptian Mines",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-081",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-044.png",
    name: "Dota Hi-Lo",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-044",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-047.png",
    name: "Heist",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-047",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-087.png",
    name: "COLOR GAME MEGA BONUS",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-087",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-085.png",
    name: "Teen Patti Blitz",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-085",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-083.png",
    name: "BURMESE 6 ANIMALS",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-083",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-084.png",
    name: "Speedy Andar Bahar",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-084",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-080.png",
    name: "Jogo de Bozó",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-080",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-082.png",
    name: "Bicho",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-082",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-079.png",
    name: "LADDER GAME",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-079",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-019.png",
    name: "Thai Fish Prawn Crab",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-019",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-017.png",
    name: "taixiu",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-017",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },


{
    img: "../assets/images/Table/kingmaker/KM-TABLE-010.png",
    name: "belangkai 2",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-010",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-011.png",
    name: "dragon-tiger2",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-011",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-046.png",
    name: "Teen Patti",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-046",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-027.png",
    name: "european roulette",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-027",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
 
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-023.png",
    name: "xocdia2",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-023",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-051.png",
    name: "KM Power Ball",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-051",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-034.png",
    name: "KM Pok Deng",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-034",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-024.png",
    name: "Fan Tan Classic",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-024",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-052.png",
    name: "BolaTangkas",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-052",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-029.png",
    name: "bai buu",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-029",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-065.png",
    name: "Pusoy",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-065",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-025.png",
    name: "Fruit Roulette",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-025",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-020.png",
    name: "Bài Cào",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-020",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-2.webp",
    name: "Cash Rocket",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-041",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-074.webp",
    name: "Ludo Quick",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-074",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-073.webp",
    name: "Video Poker",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-073",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-069.webp",
    name: "Elite Aviator Club",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-069",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/KM-TABLE-070.webp",
    name: "Interstellar Run",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-070",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/KM-TABLE-071.webp",
    name: "Olympus Glory",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-071",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-066.webp",
    name: "Coin Pusher",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-066",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-067.webp",
    name: "Cockfighting Arena",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-067",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-063.webp",
    name: "Tongits",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-063",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/TABLE-3.webp",
    name: "Ludo",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-060",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-053.webp",
    name: "Marble Knockout",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-053",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-16.webp",
    name: "Colour Game",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-050",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-048.webp",
    name: "Horse Racing",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-048",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-055.webp",
    name: "KM Virtual Greyhound Racing",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-055",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-058.webp",
    name: "KM Virtual Treadmill Racing",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-058",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-062.webp",
    name: "KM Virtual Treadmill Racing",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-062",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-049.webp",
    name: "5 Card Poker",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-049",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-040.webp",
    name: "Plinko",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-040",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-12.webp",
    name: "Bonus Dice",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-043",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-15.webp",
    name: "keno",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-018",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-045.webp",
    name: "Monkey King Roulette",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-045",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-5.webp",
    name: "sicbo",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-015",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-4.webp",
    name: "7 Up 7 Down",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-028",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/TABLE-6.webp",
    name: "Coin Toss",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-036",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-7.webp",
    name: "Cards Hi Lo",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-037",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/NETENT-TABLE-001.png",
    name: "Classic Blackjack",
    platForm: "NETENT",
    gameType: "TABLE",
    casinoType: "NETENT-TABLE-001",
    cateogry: "NETENT",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-9.webp",
    name: "Card Matka",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-022",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-021.webp",
    name: "Number Matka",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-021",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-032.webp",
    name: "Andar Bahar",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-032",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/TABLE-13.webp",
    name: "32 Cards",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-039",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/KM-TABLE-038.webp",
    name: "Blackjack",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-038",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-042.webp",
    name: "Minesweeper",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-042",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-035.webp",
    name: "Bola Golek",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-035",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-030.webp",
    name: "jhandimunda",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-030",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  // Table End KINGMAKER (casino Done) -------

  // Table Start JILI (casino Done) -------

 {
    img: "../assets/images/Table/jili/JILI-TABLE-077.png",
    name: "Golden Treasure",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-077",
    cateogry: "JILI",
    type: "TABLE",
  },
 {
    img: "../assets/images/Table/jili/JILI-TABLE-061.png",
    name: "Ultimate Texas Hold'em",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-061",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-056.png",
    name: "Jhandi Munda",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-056",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-054.png",
    name: "Speed Baccarat",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-054",
    cateogry: "JILI",
    type: "TABLE",
  },


{
    img: "../assets/images/Table/jili/JILI-TABLE-023.png",
    name: "color game",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-023",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-039.png",
    name: "Color Prediction",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-039",
    cateogry: "JILI",
    type: "TABLE",
  },

  {
    img: "../assets/images/JILI/JILI-TABLE-039.webp",
    name: "Color Prediction",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-039",
    cateogry: "JILI",
    type: "TABLE",
  },


{
    img: "../assets/images/Table/jili/JILI-TABLE-052.png",
    name: "Jogo do Bicho",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-052",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-038.png",
    name: "Pusoy Go",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-038",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-025.png",
    name: "Tongits Go",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-025",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-044.png",
    name: "Blackjack",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-044",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-046.png",
    name: "Blackjack Lucky Ladies",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-046",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-049.png",
    name: "Caribbean Stud Poker",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-049",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-053.png",
    name: "European Roulette",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-053",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-050.png",
    name: "Video Poker",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-050",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-078.png",
    name: "Color Game Extreme",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-078",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-073.png",
    name: "Domino Go",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-073",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-071.png",
    name: "Keno Super Chance",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-071",
    cateogry: "JILI",
    type: "TABLE",
  },


{
    img: "../assets/images/Table/jili/JILI-TABLE-040.png",
    name: "Keno",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-040",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-040.png",
    name: "Keno",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-040",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-069.png",
    name: "Cricket War",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-069",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-070.png",
    name: "Crash Touchdown",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-070",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-063.png",
    name: "Thai Hilo",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-063",
    cateogry: "JILI",
    type: "TABLE",
  },

{
  
    img: "../assets/images/Table/jili/JILI-TABLE-064.png",
    name: "Super E-Sabong",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-064",
    cateogry: "JILI",
    type: "TABLE",
  },

{
  
    img: "../assets/images/Table/jili/JILI-TABLE-060.png",
    name: "Cricket Roulette",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-060",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
  
    img: "../assets/images/Table/jili/JILI-TABLE-065.png",
    name: "Keno Bonus Number",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-065",
    cateogry: "JILI",
    type: "TABLE",
  },
  

  {
  
    img: "../assets/images/Table/jili/JILI-TABLE-041.png",
    name: "Plinko",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-041",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-055.webp",
    name: "Crash Goal",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-055",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-057.webp",
    name: "Fish Prawn Crab",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-057",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-058.webp",
    name: "Crash Cricket",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-058",
    cateogry: "JILI",
    type: "TABLE",
  },

  {
    img: "../assets/images/JILI/JILI-TABLE-021.webp",
    name: "Ludo Quick",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-021",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-014.webp",
    name: "Baccarat",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-014",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-017.webp",
    name: "Sic Bo",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-017",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-016.webp",
    name: "TeenPatti 20-20",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-016",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/JILI-TABLE-047.png",
    name: "Crash Bonus",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-047",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/JILI-TABLE-048.png",
    name: "Pool Rummy",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-048",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/JILI-TABLE-042.png",
    name: "Mini Flush",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-042",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-018.webp",
    name: "Super Bingo",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-018",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-015.webp",
    name: "Fortune Bingo",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-015",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-011.webp",
    name: "7up7down",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-011",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-013.webp",
    name: "Callbreak Quick",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-013",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-012.webp",
    name: "Dragon & Tiger",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-012",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-010.webp",
    name: "TeenPatti Joker",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-010",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-008.webp",
    name: "iRich Bingo",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-008",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-009.webp",
    name: "Callbreak",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-009",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-003.webp",
    name: "Andar Bahar",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-003",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-004.webp",
    name: "Rummy",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-004",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-005.webp",
    name: "NumberKing",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-005",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/JILI-TABLE-033.png",
    name: "Mines",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-033",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-027.webp",
    name: "Golden Land",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-027",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-006.webp",
    name: "Poker King",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-006",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-007.webp",
    name: "Big small",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-007",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-028.webp",
    name: "PAPPU",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-028",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-035.webp",
    name: "Limbo",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-035",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-036.webp",
    name: "wheel",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-036",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-032.webp",
    name: "HILO",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-032",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-030.webp",
    name: "Go Rush",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-030",
    cateogry: "JILI",
    type: "TABLE",
  },

  {
    img: "../assets/images/JILI/JILI-TABLE-002.webp",
    name: "AK47",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-002",
    cateogry: "JILI",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/JILI-TABLE-031.png",
    name: "Tower",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-031",
    cateogry: "JILI",
    type: "TABLE",
  },

  // Table End JILI (casino Done) -------

  // Other

  {
    img: "../assets/images/Others/MX-LIVE-015_SEXY.webp",
    name: "Thai Fish Prawn Crab",
    casinoType: "MX-LIVE-015",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    cateogry: "SEXY",
    table: "126",
    type: "OTHERS",
  },
  // {
  //   img: "../assets/images/live/sexy/MX-LIVE-018.webp",
  //   name: "Pok Deng",
  //   platForm: "SEXYBCRT",
  //   gameType: "LIVE",
  //   casinoType: "MX-LIVE-018",
  //   cateogry: "SEXY",
  //   type: "OTHERS",
  //   isPopular: true,
  // },

{
    img: "../assets/images/live/sexy/MX-LIVE-015.webp",
    name: "Thai Fish Prawn Crab",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-015",
    cateogry: "SEXY",
    type: "OTHERS",
    isPopular: true,
  },


{
    img: "../assets/images/live/sexy/MX-LIVE-017.webp",
    name: "Sedie",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-017",
    cateogry: "SEXY",
    type: "OTHERS",
    isPopular: true,
  },





{
    img: "../assets/images/live/sexy/MX-LIVE-001.webp",
    name: "SEXY Game Lobby",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "OTHERS",
    isPopular: true,
  },
{
    img: "../assets/images/live/sexy/MX-LIVE-006.webp",
    name: "Dragon Tiger",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-006",
    cateogry: "SEXY",
    type: "OTHERS",
    isPopular: true,
  },
{
    img: "../assets/images/live/sexy/MX-LIVE-002.webp",
    name: "Baccarat",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-002",
    cateogry: "SEXY",
    type: "OTHERS",
    isPopular: true,
  },



  {
    img: "../assets/images/Others/HOTROAD-LIVE-005.webp",
    name: "HOTROAD-LIVE-005",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-005",
    cateogry: "HOTROAD",
    type: "OTHERS",
    table: "3001",
  },
  // {
  //   img: "../assets/images/Others/VN-LIVE-008.webp",
  //   name: "Thai Fish Prawn Crab",
  //   casinoType: "VN-LIVE-008",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   cateogry: "VENUS",
  //   type: "OTHERS",
  // },
  // Other
  // Slot Start PP (casino Done) -----

  {
    img: "../assets/images/slot/NETENT-SLOT-008.png",
    name: "Starburst™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-008",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-017.png",
    name: "Starburst™ XXXtreme",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-017",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-009.png",
    name: "Gonzo's Quest™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-009",
    cateogry: "NETENT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/NETENT-SLOT-014.png",
    name: "Divine Fortune™ Megaways™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-014",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-013.png",
    name: "Divine Fortune™ Megaways™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-013",
    cateogry: "NETENT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/NETENT-SLOT-010.png",
    name: "Finn's Golden Tavern™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-010",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-018.png",
    name: "Twin Spin™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-018",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-025.png",
    name: "Jimi Hendrix Online Slot™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-025",
    cateogry: "NETENT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/NETENT-SLOT-006.png",
    name: "Parthenon: Quest for Immortality™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-006",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-027.png",
    name: "Wild Wild West: The Great Train Heist™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-027",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-001.png",
    name: "Reel Rush™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-001",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-002.png",
    name: "Dracula™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-002",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-003.png",
    name: "Riches of Midgard: Land and Expand™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-003",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-004.png",
    name: "Dark King: Forbidden Riches™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-004",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-005.png",
    name: "Dead or Alive 2™ Feature Buy",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-005",
    cateogry: "NETENT",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/NETENT-SLOT-006.png",
  //   name: "Parthenon: Quest for Immortality™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-006",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/NETENT-SLOT-007.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-007",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-011.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-011",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-012.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-012",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-015.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-015",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-016.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-016",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-019.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-019",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-020.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-020",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-021.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-021",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-022.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-022",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-023.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-023",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-024.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-024",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-026.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-026",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-028.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-028",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-029.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-029",
    cateogry: "NETENT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/NETENT-SLOT-177.webp",
    name: "101 Candies",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-177",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-178.webp",
    name: "Big Bang Boom",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-178",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-179.webp",
    name: "Crab Trap™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-179",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-180.webp",
    name: "Jack and the Beanstalk Remastered",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-180",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-181.webp",
    name: "Thrill to Grill™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-181",
    cateogry: "NETENT",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/PT-SLOT-082.webp",
  //   name: "Football Rules",
  //   platForm: "PLAYTECH",
  //   gameType: "SLOT",
  //   casinoType: "PT-SLOT-082",
  //   cateogry: "PP",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-003.webp",
    name: "777",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-003",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-004.webp",
    name: "Get Money",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-004",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-012.webp",
    name: "Over Dragon's Gate",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-012",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-002.webp",
    name: "Phoenix",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-002",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-011.webp",
    name: "Diamond Mogul",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-011",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-005.webp",
    name: "Rich Now",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-005",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-008.webp",
    name: "Dracula",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-008",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-020.webp",
    name: "Bust Treasury",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-020",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-448.webp",
    name: "Arowanas Luck",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-448",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-449.webp",
    name: "Arowanas Luck",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-449",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-450.webp",
    name: "Arowanas Luck",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-450",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-002.webp",
    name: "Gates of Olympus",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-002",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-082.webp",
    name: "Sweet Bonanza",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-082",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-189.webp",
    name: "Starlight Princess",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-189",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-183.webp",
    name: "5 Lions Megaways",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-183",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-080.webp",
    name: "5 Lions Gold",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-080",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-049.webp",
    name: "Great Rhino Megaways",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-049",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-069.webp",
    name: "Fire Strike",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-069",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-067.webp",
    name: "Sweet Bonanza Xmas",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-067",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-015.webp",
    name: "Bonanza Gold",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-015",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-176.webp",
    name: "Buffalo King Megaways",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-176",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-181.webp",
    name: "The Magic Cauldron - Enchanted Brew",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-181",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-046.webp",
    name: "Fruit Party",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-046",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-187.webp",
    name: "Pyramid Bonanza",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-187",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-204.webp",
    name: "Candy Village",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-204",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-126.webp",
    name: "3 Kingdoms - Battle of Red Cliffs",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-126",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-104.webp",
    name: "5 Lions",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-104",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-072.webp",
    name: "John Hunter and the Tomb of the Scarab Queen",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-072",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-107.webp",
    name: "Joker's Jewels",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-107",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-025.webp",
    name: "Gems Bonanza",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-025",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-210.webp",
    name: "Santa's Wonderland",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-210",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-233.webp",
    name: "Wild West Gold Megaways",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-233",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-234.webp",
    name: "Spirit of Adventure",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-234",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-235.webp",
    name: "Fire Strike 2",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-235",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-236.webp",
    name: "Barn Festival",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-236",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-237.webp",
    name: "Chicken Chase",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-237",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-238.webp",
    name: "Goblin Heist Powernudge",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-238",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-239.webp",
    name: "Eye of Cleopatra",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-239",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-240.webp",
    name: "The Great Stick-Up",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-240",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-296.webp",
    name: "Aztec Blaze",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-296",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-297.webp",
    name: "Starlight Christmas",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-297",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-298.webp",
    name: "Towering Fortunes",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-298",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-299.webp",
    name: "Firebird Spirit",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-299",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-300.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-300",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-409.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-409",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-410.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-410",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-413.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-413",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-414.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-414",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-415.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-415",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-416.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-416",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-417.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-417",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-418.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-418",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-419.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-419",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-420.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-420",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-421.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-421",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-422.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-422",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-423.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-423",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-424.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-424",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-425.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-425",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-426.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-426",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-427.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-427",
    cateogry: "PP",
    type: "SLOT",
  },
  // Slot End PP (casino Done) -----

  // Slot Start KINGMAKER (casino Done) -----
  
 {
    img: "../assets/images/slot/KM-SLOT-016.webp",
    name: "Hippo Splash",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-016",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
 {
    img: "../assets/images/slot/KM-SLOT-018.png",
    name: "Rome Gladiator",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-018",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
 {
    img: "../assets/images/slot/KM-SLOT-017.webp",
    name: "Cupid Archery",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-017",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

 {
    img: "../assets/images/slot/KM-SLOT-019.png",
    name: "Hunk Cai Shen",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-019",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

 {
    img: "../assets/images/slot/KM-SLOT-009.png",
    name: "LEPPY LOOT",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-009",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

 {
    img: "../assets/images/slot/KM-SLOT-015.webp",
    name: "Pirate's Treasure",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-015",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

{
    img: "../assets/images/slot/KM-SLOT-013.png",
    name: "London Mystery",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-013",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

{
    img: "../assets/images/slot/KM-SLOT-012.webp",
    name: "Merlin's Saga",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-012",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },


{
    img: "../assets/images/slot/KM-SLOT-011.png",
    name: "Piggy Heist",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-011",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

{
    img: "../assets/images/slot/KM-SLOT-010.webp",
    name: "Gold Rush Bonanza",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-010",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/KM-SLOT-008.webp",
    name: "Warriors Temple",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-008",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
 {
    img: "../assets/images/slot/KM-SLOT-002.webp",
    name: "Gems of Valhalla",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-002",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
 {
    img: "../assets/images/slot/KM-SLOT-006.webp",
    name: "GOld mine",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-006",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/KM-SLOT-003.webp",
    name: "Sugar Blast Frenzy",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-003",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/KM-TABLE-066.webp",
    name: "Coin Pusher",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-066",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/KM-SLOT-007.webp",
    name: "Almighty Greek",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-007",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/KM-SLOT-004.png",
    name: "Cleopatra's Treasure",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-004",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
 {
    img: "../assets/images/slot/KM-SLOT-005.webp",
    name: "Rooster Blitz",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-005",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/KM-SLOT-001.webp",
    name: "Sugar Blast",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-001",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
 
  // Slot End KINGMAKER (casino Done) -----

  // Slot Start DRAGOONSOFT (casino Done) -----

  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-001.webp",
    name: "Coin Cat",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-001",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-015.webp",
    name: "Egypt Oracle",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-015",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-018.webp",
    name: "Rich Lion",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-018",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-017.webp",
    name: "Candy Dynasty",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-017",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-007.webp",
    name: "Doggy Wealth",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-007",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-016.webp",
    name: "Caishen Coming",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-016",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-006.webp",
    name: "Chef Lady",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-006",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-009.webp",
    name: "Maya King",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-009",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-010.webp",
    name: "Pirate King",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-010",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-013.webp",
    name: "Great Lion",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-013",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-014.webp",
    name: "Ultra Treasure",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-014",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-019.webp",
    name: "Monkey King",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-019",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-075.webp",
    name: "Mahjong Win",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-075",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-076.webp",
    name: "Super Hoo Hey How",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-076",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  // Slot End DRAGOONSOFT (casino Done) -----

  // Slot Start SPADE (casino Done) -----
  // {
  //   img: "../assets/images/slot/SG-SLOT-106.webp",
  //   name: "Fiery Sevens Exclusive",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-106",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-074.webp",
  //   name: "Mega7",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-074",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-116.webp",
  //   name: "Legacy Of Kong Maxways",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-116",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-069.webp",
  //   name: "888",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-069",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-112.webp",
  //   name: "Fruits Mania",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-112",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-076.webp",
  //   name: "DoubleFlame",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-076",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-110.webp",
  //   name: "Space Conquest",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-110",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-081.webp",
  //   name: "Triple Panda",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-081",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-077.webp",
  //   name: "Book of Myth",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-077",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-095.webp",
  //   name: "Poker Ways",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-095",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },

  // {
  //   img: "../assets/images/slot/SG-SLOT-086.webp",
  //   name: "Mayan Gems",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-086",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-075.webp",
  //   name: "JokersTreasure",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-075",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-030.webp",
  //   name: "5FortuneSA",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-030",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-103.webp",
  //   name: "Sexy Vegas",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-103",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-107.webp",
  //   name: "Lucky Koi Exclusive",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-107",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-082.webp",
  //   name: "Gold Panther",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-082",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-032.webp",
  //   name: "Golden Lotus SE",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-032",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-105.webp",
  //   name: "Royale House",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-105",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // Slot End SPADE (casino Done) -----

  // Slot Start PT (casino Done) -----
  {
    img: "../assets/images/slot/PT-SLOT-082.webp",
    name: "Football Rules",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-082",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-063.png",
    name: "Football Rules",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-063",
    cateogry: "PT",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/PT-SLOT-064.png",
  //   name: "Football Rules",
  //   platForm: "PLAYTECH",
  //   gameType: "SLOT",
  //   casinoType: "PT-SLOT-064",
  //   cateogry: "PT",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/PT-SLOT-065.png",
    name: "Football Rules",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-065",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-066.png",
    name: "Football Rules",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-066",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-067.png",
    name: "Football Rules",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-067",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-068.png",
    name: "Football Rules",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-068",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-069.png",
    name: "Football Rules",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-069",
    cateogry: "PT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/PT-SLOT-070.webp",
    name: "Heart of the Frontier",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-070",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-071.webp",
    name: "Thai Paradise",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-071",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-072.webp",
    name: "Legacy of the Wild",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-072",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-073.webp",
    name: "Archer",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-073",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-001.webp",
    name: "Triple Monkey",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-001",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-003.webp",
    name: "Buffalo Blitz",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-003",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-006.webp",
    name: "Great Blue",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-006",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-004.webp",
    name: "Captain Treasure",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-004",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-005.webp",
    name: "Long Long Long",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-005",
    cateogry: "PT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/PT-SLOT-009.webp",
    name: "Golden Tour",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-009",
    cateogry: "PT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/PT-SLOT-010.webp",
    name: "Funky Monkey",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-010",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-011.webp",
    name: "Highway Kings",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-011",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-014.webp",
    name: "Zhao Cai Tong Zi",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-014",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-012.webp",
    name: "Zhao Cai Jin Bao",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-012",
    cateogry: "PT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/PT-SLOT-013.webp",
    name: "Jin Qian Wa",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-013",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-015.webp",
    name: "Ugga Bugga",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-015",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-016.webp",
    name: "Safari Heat",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-016",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-002.webp",
    name: "Arowanas Luck",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-002",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-019.webp",
    name: "Gem Queen",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-019",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-023.webp",
    name: "Chaoji 888",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-023",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-008.webp",
    name: "Blue Wizard",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-008",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-018.webp",
    name: "Bonus Bears",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-018",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-017.webp",
    name: "Buffalo Blitz II",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-017",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-007.webp",
    name: "Sky Queen",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-007",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-020.webp",
    name: "Feng Kuang Ma Jiang",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-020",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-021.webp",
    name: "Epic Ape",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-021",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-022.webp",
    name: "Ni Shu Shen Me",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-022",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-024.webp",
    name: "Vacation Station Deluxe",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-024",
    cateogry: "PT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/PT-SLOT-025.webp",
    name: "Eternal Lady",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-025",
    cateogry: "PT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/PT-SLOT-026.webp",
    name: "Golden Macaque",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-026",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-027.webp",
    name: "Fei Long Zai Tian",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-027",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-028.webp",
    name: "Yun Cong Long",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-028",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-029.webp",
    name: "Jinfu Long",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-029",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-030.webp",
    name: "Hot Gems",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-030",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-031.webp",
    name: "Lie Yan Zuan Shi",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-031",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-032.webp",
    name: "Dolphin Reef",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-032",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-033.webp",
    name: "Jinns Moon",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-033",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-034.webp",
    name: "Tiger, Turtle, Dragon, Phoenix",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-034",
    cateogry: "PT",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/PT-SLOT-035.webp",
  //   name: "Heart of the Jungle",
  //   platForm: "PLAYTECH",
  //   gameType: "SLOT",
  //   casinoType: "PT-SLOT-035",
  //   cateogry: "PT",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/PT-SLOT-036.webp",
    name: "Heavenly Ruler",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-036",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-037.webp",
    name: "Ox Riches",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-037",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-038.webp",
    name: "Ice Cave",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-038",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-039.webp",
    name: "Queen of Wands",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-039",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-040.webp",
    name: "Si Xiang",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-040",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-041.webp",
    name: "Panther Moon",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-041",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-043.webp",
    name: "Asian Fantasy",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-043",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-044.webp",
    name: "Fortune Lions",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-044",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-045.webp",
    name: "Hot KTV",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-045",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-046.webp",
    name: "Fortune Day",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-046",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-047.webp",
    name: "Ri Ri Jin Cai",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-047",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-048.webp",
    name: "Sun WuKong",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-048",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-049.webp",
    name: "Ji Xiang 8",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-049",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-050.webp",
    name: "Jade Emperor Yu Huang Da Di",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-050",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-051.webp",
    name: "Halloween Fortune 2",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-051",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-060.webp",
    name: "Chinese Kitchen",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-060",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-061.webp",
    name: "Geisha Story",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-061",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-062.webp",
    name: "Fortunes of the Fox",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-062",
    cateogry: "PT",
    type: "SLOT",
  },
  // Slot End PT (casino Done) -----

  // Slot Start JDB (casino Done) -----
  {
    img: "../assets/images/slot/JDB-SLOT-108.webp",
    name: "Moneybags Man 2",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-108",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-106.webp",
    name: "FortuneNeko",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-106",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-107.webp",
    name: "Trump Card",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-107",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-105.webp",
    name: "BookOfMystery",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-105",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-117.png",
    name: "BigThreeDragons",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-117",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-001.webp",
  //   name: "Burglar",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-001",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-003.webp",
  //   name: "Chef Doeuvre",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-003",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-004.webp",
  //   name: "Lucky Miner",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-004",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-005.webp",
  //   name: "Candy Land",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-005",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-006.webp",
  //   name: "Crazy Scientist",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-006",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-007.webp",
  //   name: "Super Dumpling",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-007",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-008.webp",
  //   name: "Cash Man",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-008",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-009.webp",
    name: "Wild Beauty",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-009",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-010.webp",
    name: "Flirting Scholar Tang",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-010",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-011.webp",
    name: "Winning Mask",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-011",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-012.webp",
    name: "Wu kong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-012",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-013.webp",
    name: "Llama Adventure",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-013",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-014.webp",
    name: "Formosa Bear",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-014",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-015.webp",
  //   name: "Lucky Qilin",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-015",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-016.webp",
    name: "New Year",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-016",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-017.webp",
    name: "Four Treasures",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-017",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-018.webp",
    name: "Open Sesame",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-018",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-019.webp",
    name: "Banana Saga",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-019",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-020.webp",
    name: "Olympian Temple",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-020",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-021.webp",
  //   name: "Dancing Pa Pa",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-021",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-022.webp",
  //   name: "Dragon King",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-022",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-023.webp",
  //   name: "Magic Show",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-023",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-024.webp",
  //   name: "Cock Fight",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-024",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
   {
    img: "../assets/images/slot/JDB-SLOT-025.webp",
    name: "Dragon",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-025",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-026.webp",
    name: "Rooster In Love",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-026",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-027.webp",
  //   name: "Monkey King",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-027",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-028.webp",
    name: "Moonlight Treasure",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-028",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-029.webp",
    name: "Mahjong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-029",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-030.webp",
  //   name: "Guan Gong",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-030",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-031.webp",
    name: "Billionaire",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-031",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-032.webp",
    name: "Dragon Warrior",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-032",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-033.webp",
    name: "Kingsman",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-033",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-034.webp",
  //   name: "Curvy Magician",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-034",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-035.webp",
  //   name: "RollingIn Money",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-035",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-036.webp",
  //   name: "Chef Panda",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-036",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-045.webp",
    name: "Lucky Dragons",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-045",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-046.webp",
  //   name: "Lucky Lion",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-046",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-047.webp",
  //   name: "Coffeeholics",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-047",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-048.webp",
    name: "Napoleon",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-048",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-049.webp",
  //   name: "Lucky Phoenix",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-049",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-050.webp",
    name: "WinningMask II",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-050",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-051.webp",
    name: "Open Sesame II",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-051",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-052.webp",
  //   name: "Flirting Scholar Tang II",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-052",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-053.webp",
    name: "Fortune Horse",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-053",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-054.webp",
    name: "Xi Yang Yang",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-054",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-055.webp",
  //   name: "Panda Panda",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-055",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-056.webp",
  //   name: "Zelda",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-056",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-057.webp",
  //   name: "Mr Bao",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-057",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-058.webp",
  //   name: "One Punch Man",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-058",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-059.webp",
  //   name: "Guardians of The Galaxy",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-059",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-060.webp",
  //   name: "Street Fighter",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-060",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-061.webp",
  //   name: "Star Wars",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-061",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-062.webp",
  //   name: "War of Beauty",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-062",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-063.webp",
  //   name: "Daji",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-063",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-064.webp",
  //   name: "Poker King",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-064",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-065.webp",
  //   name: "Lucky Racing",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-065",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-066.webp",
    name: "Birds Party",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-066",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-067.webp",
    name: "Go Lai Fu",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-067",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-068.webp",
  //   name: "Gems Gems",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-068",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-069.webp",
    name: "Dragons World",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-069",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-070.webp",
    name: "Super Niubi",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-070",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-071.webp",
  //   name: "Egypt Treasure",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-071",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-072.webp",
    name: "Fortune Treasure",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-072",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-073.webp",
  //   name: "Pirate Treasure",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-073",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-074.webp",
    name: "Mjoinir",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-074",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-075.webp",
    name: "Treasure Bowl",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-075",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-076.webp",
    name: "Funky King Kong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-076",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-077.webp",
    name: "Super Niubi Deluxe",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-077",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-078.webp",
  //   name: "Super Niubi",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-078",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-079.webp",
  //   name: "Lucky Fuwa",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-079",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-080.webp",
  //   name: "Inca Empire",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-080",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-081.webp",
  //   name: "Ninja Rush",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-081",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-082.webp",
  //   name: "Sun Archer",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-082",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-083.webp",
  //   name: "Mystery of Nine Tales",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-083",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-084.webp",
    name: "Golden Disco",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-084",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-085.webp",
    name: "Miner Babe",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-085",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-086.webp",
    name: "Moneybags Man",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-086",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-087.webp",
    name: "Double Wilds",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-087",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-088.webp",
  //   name: "Pop Pop Fruity",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-088",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-089.webp",
    name: "Spindrift",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-089",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-090.webp",
    name: "Spindrift 2",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-090",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-091.webp",
  //   name: "Jungle Jungle",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-091",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-092.webp",
    name: "Dragons Gate",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-092",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-093.webp",
    name: "Lucky Diamond",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-093",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-094.webp",
    name: "Kong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-094",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-095.webp",
  //   name: "NinjaX",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-095",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-096.webp",
  //   name: "Rex Brothers",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-096",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-097.webp",
    name: "Wonder Elephant",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-097",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-098.webp",
    name: "MarvelousIV",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-098",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-099.webp",
    name: "Maya Gold Crazy",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-099",
    cateogry: "JDB",
    type: "SLOT",
  },
  // Slot End JDB (casino Done) -----

  // Slot Start FC (casino Done) -----

  // {
  //   img: "../assets/images/slot/FC-SLOT-025.webp",
  //   name: "SUGAR BANG BANG",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-025",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-021.webp",
  //   name: "Lucky Fortunes",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-021",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-020.webp",
  //   name: "Robin Hood",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-020",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-019.webp",
  //   name: "GLORY OF ROME",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-019",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-001.webp",
  //   name: "GOLDEN PANTHER",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-001",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-002.webp",
  //   name: "THREE LITTLE PIGS",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-002",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-003.webp",
  //   name: "HOT POT PARTY",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-003",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-004.webp",
  //   name: "NIGHT MARKET",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-004",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-005.webp",
  //   name: "PONG PONG HU",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-005",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-006.webp",
  //   name: "PANDA DRAGON BOAT",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-006",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-007.webp",
  //   name: "CHINESE NEW YEAR",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-007",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-008.webp",
  //   name: "FORTUNE KOI",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-008",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-009.webp",
  //   name: "HAPPY DUO BAO",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-009",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-010.webp",
  //   name: "	DA LE MEN",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-010",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-011.webp",
  //   name: "ANIMAL RACING",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-011",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-012.webp",
  //   name: "LUXURY GOLDEN PANTHER",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-012",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-013.webp",
  //   name: "MAGIC BEANS",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-013",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-014.webp",
  //   name: "COWBOYS",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-014",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-015.webp",
  //   name: "WAR OF THE UNIVERSE",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-015",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-016.webp",
  //   name: "TREASURE CRUISE",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-016",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // Slot End FC (casino Done) -----

  // Slot Start JILI (casino Done) -----

  // Slot Start JILI (casino Done) -----

  {
    img: "../assets/images/slot/JILI-SLOT-027.webp",
    name: "Super Ace",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-031.webp",
    name: "Boxing King",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-031",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-029.webp",
    name: "Money Coming",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-029",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot2/JILI-SLOT-130.webp",
    name: "Super Ace 2",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-130",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot2/JILI-SLOT-118.webp",
    name: "Super Ace Joker",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-118",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot2/JILI-SLOT-102.webp",
    name: "Super Ace Joker",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-102",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot2/JILI-SLOT-112.webp",
    name: "Super Ace Joker",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-112",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot2/JILI-SLOT-123.webp",
    name: "Super Ace Joker",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-123",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot2/JILI-SLOT-146.webp",
    name: "Super Ace Joker",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-146",
    cateogry: "JILI",
    type: "SLOT",
  },


  {
    img: "../assets/images/slot2/JILI-SLOT-155.webp",
    name: "Super Ace Joker",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-155",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot2/JILI-SLOT-149.webp",
    name: "Super Ace Joker",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-149",
    cateogry: "JILI",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot2/JILI-SLOT-114.webp",
    name: "Super Ace Joker",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-114",
    cateogry: "JILI",
    type: "SLOT",
  },
 {
    img: "../assets/images/slot/JILI-SLOT-023.webp",
    name: "Golden Bank",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-023",
    cateogry: "JILI",
    type: "SLOT",
  },

{
    img: "../assets/images/slot/JILI-SLOT-049.png",
    name: "Alibaba",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-049",
    cateogry: "JILI",
    type: "SLOT",
  },

{
    img: "../assets/images/slot/JILI-SLOT-137.png",
    name: "Joker Coin",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-137",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-110.png",
    name: "Shōgun",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-110",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-094.png",
    name: "Devil Fire 2",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-094",
    cateogry: "JILI",
    type: "SLOT",
  },
 {
    img: "../assets/images/slot/JILI-SLOT-022.webp",
    name: "Fengshen",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-022",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-121.png",
    name: "Poseidon's ",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-121",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-101.png",
    name: "3 Coin Treasures ",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-101",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-127.png",
    name: "Bikini Lady",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-127",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-050.png",
    name: "Samba",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-050",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-089.png",
    name: "Sin City",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-089",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-079.png",
    name: "Sweet Land",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-079",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-072.png",
    name: "Wild Racer",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-072",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-095.png",
    name: "Witches Night",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-095",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-063.webp",
    name: "World Cup",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-063",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-058.png",
    name: "World Cup",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-058",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-086.png",
    name: "World Cup",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-086",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-056.webp",
    name: "Happy Taxi",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-056",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-057.webp",
    name: "Gold Rush",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-057",
    cateogry: "JILI",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/JILI-SLOT-054.webp",
    name: "Crazy Pusher",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-054",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-053.webp",
    name: "Book of Gold",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-053",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-071.webp",
    name: "Neko Fortune",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-071",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-051.webp",
    name: "Mega Ace",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-051",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-052.webp",
    name: "Thor X",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-052",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-002.webp",
    name: "Hot Chilli",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-002",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-003.webp",
    name: "Chin Shi Huang",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-003",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-004.webp",
    name: "War Of Dragons",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-004",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-005.webp",
    name: "Fortune Tree",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-005",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-006.webp",
    name: "Lucky Ball",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-006",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-007.webp",
    name: "Hyper Burst",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-007",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-008.webp",
    name: "Shanghai Beauty",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-008",
    cateogry: "JILI",
    type: "SLOT",
  },
 
 
  {
    img: "../assets/images/slot/JILI-SLOT-009.webp",
    name: "Fa Fa Fa",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-009",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-010.webp",
    name: "God Of Martial",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-010",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-012.webp",
    name: "Hawaii Beauty",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-012",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-013.webp",
    name: "SevenSevenSeven",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-013",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-014.webp",
    name: "Crazy777",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-014",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-015.webp",
    name: "Bubble Beauty",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-015",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-016.webp",
    name: "Bao boon chin",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-016",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-017.webp",
    name: "Crazy FaFaFa",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-017",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-018.webp",
    name: "XiYangYang",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-018",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-019.webp",
    name: "FortunePig",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-019",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-020.webp",
    name: "Candy Baby",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-020",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-021.webp",
    name: "Diamond Party",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-021",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-024.webp",
    name: "Lucky Goldbricks",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-024",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-025.webp",
    name: "Dragon Treasure",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-025",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-026.webp",
    name: "Charge Buffalo",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-026",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-028.webp",
    name: "Jungle King",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-028",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-030.webp",
    name: "Golden Queen",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-030",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-032.webp",
    name: "Matka India",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-032",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-037.webp",
    name: "Lucky Coming",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-037",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-038.webp",
    name: "Pharaoh Treasure",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-038",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-039.webp",
    name: "Secret Treasure",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-039",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-040.webp",
    name: "RomaX",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-040",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-041.webp",
    name: "Super Rich",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-041",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-042.webp",
    name: "Golden Empire",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-042",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-043.webp",
    name: "Fortune Gems",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-043",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-044.webp",
    name: "Party Night",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-044",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-045.webp",
    name: "Crazy Hunter",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-045",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-046.webp",
    name: "Magic Lamp",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-046",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-047.webp",
    name: "TWINWINS",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-047",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-048.webp",
    name: "Agent Ace",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-048",
    cateogry: "JILI",
    type: "SLOT",
  },
  // Slot End JILI (casino Done) -----

  //slot spade start
  {
    img: "../assets/images/slot/SG-SLOT-106.png",
    name: "Fiery Sevens Exclusive",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-106",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-074.png",
    name: "Mega7",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-074",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-116.png",
    name: "Legacy Of Kong Maxways",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-116",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-069.webp",
    name: "888",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-069",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-112.webp",
    name: "Fruits Mania",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-112",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-076.png",
    name: "DoubleFlame",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-076",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-110.webp",
    name: "Space Conquest",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-110",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-081.png",
    name: "TriplePanda",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-081",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-077.png",
    name: "BookofMyth",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-077",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-095.png",
    name: "Poker Ways",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-095",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-086.png",
    name: "Mayan Gems",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-086",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-075.png",
    name: "JokersTreasure",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-075",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-030.png",
    name: "5FortuneSA",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-030",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-103.webp",
    name: "Sexy Vegas",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-103",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-107.png",
    name: "Lucky Koi Exclusive",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-107",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-082.png",
    name: "GoldPanther",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-082",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-032.webp",
    name: "GoldenLotusSE",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-032",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-105.png",
    name: "Royale House",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-105",
    cateogry: "SPADE",
    type: "SLOT",
  },

  //slot spade end
  {
    img: "../assets/images/slot/FC-SLOT-038.webp",
    name: "Big Bang Boom",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-038",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-025.png",
    name: "SUGAR BANG BANG",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-025",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-023.png",
    name: "GRAND BLUE",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-023",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-024.png",
    name: "TREASURE RAIDERS",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-024",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-021.png",
    name: "Lucky Fortunes",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-021",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-020.png",
    name: "Robin Hood",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-020",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-019.png",
    name: "GLORY OF ROME",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-019",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-001.png",
    name: "GOLDEN PANTHER",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-001",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-002.png",
    name: "THREE LITTLE PIGS",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-002",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-003.png",
    name: "HOT POT PARTY",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-003",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-004.png",
    name: "NIGHT MARKET",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-004",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-005.png",
    name: "PONG PONG HU",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-005",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-006.png",
    name: "PANDA DRAGON BOAT",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-006",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-007.png",
    name: "CHINESE NEW YEAR",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-007",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-008.png",
    name: "FORTUNE KOI",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-008",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-009.png",
    name: "HAPPY DUO BAO",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-009",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-010.png",
    name: "DA LE MEN",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-010",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-011.png",
    name: "ANIMAL RACING",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-011",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-012.png",
    name: "LUXURY GOLDEN PANTHER",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-012",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-013.png",
    name: "MAGIC BEANS",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-013",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-014.png",
    name: "COWBOYS",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-014",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-015.png",
    name: "WAR OF THE UNIVERSE",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-015",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-016.png",
    name: "TREASURE CRUISE",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-016",
    cateogry: "FC",
    type: "SLOT",
  },

  //slot FC start

  //slot FC end

  // Fishing Start JILI (casino Done) -----
  {
    img: "../assets/images/Fishing/JDB-FISH-008.webp",
    name: "Royal Fishing",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-001",
    cateogry: "JDB",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/JDB-FISH-009.webp",
    name: "Royal Fishing",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-001",
    cateogry: "JDB",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/JDB-FISH-012.webp",
    name: "Royal Fishing",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-001",
    cateogry: "JDB",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/JDB-FISH-010.webp",
    name: "Fishing YiLuFa",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-002",
    cateogry: "JDB",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/JDB-FISH-011.webp",
    name: "Dragon Master",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-004",
    cateogry: "JDB",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/JDB-FISH-013.webp",
    name: "Fishing Legend",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-005",
    cateogry: "JDB",
    type: "FISHING",
  },

  // Fishing Start SPADE (casino Done) -----
  {
    img: "../assets/images/Fishing/SG-FISH-001.webp",
    name: "Fishing God",
    platForm: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-001",
    cateogry: "SPADE",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/SG-FISH-002.webp",
    name: "Fishing War",
    platForm: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-002",
    cateogry: "SPADE",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/SG-FISH-003.webp",
    name: "Alien Hunter",
    platForm: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-003",
    cateogry: "SPADE",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/SG-FISH-004.webp",
    name: "Zombie Party",
    platForm: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-004",
    cateogry: "SPADE",
    type: "FISHING",
  },
  // Fishing End SPADE (casino Done) -----
  // Fishing STart JILI (casino Done) -----
   {
    img: "../assets/images/Fishing/JILI-FISH-003.png",
    name: "Jackpot Fishing",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-003",
    cateogry: "JILI",
    type: "FISHING",
  },
   {
    img: "../assets/images/Fishing/JILI-FISH-005.webp",
    name: "Happy Fishing",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-005",
    cateogry: "JILI",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/JILI-FISH-007.webp",
    name: "Mega Fishing",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-007",
    cateogry: "JILI",
    type: "FISHING",
  },
 {
    img: "../assets/images/Fishing/JILI-FISH-012.png",
    name: "Ocean King Jackpot",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-012",
    cateogry: "JILI",
    type: "FISHING",
  },
 {
    img: "../assets/images/Fishing/JILI-FISH-002.webp",
    name: "Bombing Fishing",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-002",
    cateogry: "JILI",
    type: "FISHING",
  },
{
    img: "../assets/images/Fishing/JILI-FISH-004.webp",
    name: "Dinosaur Tycoon",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-004",
    cateogry: "JILI",
    type: "FISHING",
  },

{
    img: "../assets/images/Fishing/JILI-FISH-009.png",
    name: "All-star Fishing",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-009",
    cateogry: "JILI",
    type: "FISHING",
  },
{
    img: "../assets/images/Fishing/JILI-FISH-014.png",
    name: "FORTUNE ZOMBIE",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-014",
    cateogry: "JILI",
    type: "FISHING",
  },

{
    img: "../assets/images/Fishing/JILI-FISH-011.png",
    name: "Dinosaur Tycoon II",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-011",
    cateogry: "JILI",
    type: "FISHING",
  },

{
    img: "../assets/images/Fishing/JILI-FISH-008.webp",
    name: "Boom Legend",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-008",
    cateogry: "JILI",
    type: "FISHING",
  },
{
    img: "../assets/images/Fishing/JILI-FISH-006.webp",
    name: "Dragon Fortune",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-006",
    cateogry: "JILI",
    type: "FISHING",
  },


  {
    img: "../assets/images/Fishing/JILI-FISH-001.webp",
    name: "Royal Fishing",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-001",
    cateogry: "JILI",
    type: "FISHING",
  },

 
  

  // Fishing End JILI (casino Done) -----
  // EGAME SPRIBE
  {
    img: "../assets/images/Egame/22001.png",
    name: "Aviator",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22002.png",
    name: "Dice",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-003",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22008.png",
    name: "Mini Roulette",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-008",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22005.png",
    name: "Mines",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-005",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22006.png",
    name: "Spribe Hilo",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-006",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22004.png",
    name: "Plinko",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-004",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22003.png",
    name: "Goal",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-002",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22009.png",
    name: "Hotline",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-009",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22007.png",
    name: "Keno",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-007",
    cateogry: "SPRIBE",
    type: "EGAME",
  },

  // Egame Start JDB (casino Done) -----
  {
    img: "../assets/images/Egame/JDB-EGAME-017.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-017",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-012.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-012",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-013.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-013",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-014.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-014",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-015.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-015",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-016.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-016",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-002.webp",
    name: "Lucky Color Game",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-009",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-006.webp",
    name: "King Of Football",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-010",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-001.webp",
    name: "Crazy King Kong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-011",
    cateogry: "JDB",
    type: "EGAME",
  },

  {
    img: "../assets/images/Egame/JDB-EGAME-007.webp",
    name: "Super Super Fruit",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-012",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-011.webp",
    name: "Jogo Do Bicho",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-013",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-010.webp",
    name: "Beer Tycoon",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-014",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-005.webp",
    name: "CAISHEN PARTY",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-015",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-003.webp",
    name: "Birds and Animals",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-016",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-009.webp",
    name: "Classic Mario",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-017",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-004.webp",
    name: "Happy New Year",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-018",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-008.webp",
    name: "Huaguoshan Legends",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-019",
    cateogry: "JDB",
    type: "EGAME",
  },

  // Egame End JDB (casino Done) -----

  //PP EGAME START

  {
    img: "../assets/images/Egame/PP-EGAME-004.webp",
    name: "Fantastic League",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-001",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-002.webp",
    name: "Penalty Shootout",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-002",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-005.webp",
    name: "Greyhound Racing",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-005",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-003.webp",
    name: "Horse Racing",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-003",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-006.webp",
    name: "Force 1",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-006",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-007.webp",
    name: "Darts",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-007",
    cateogry: "PP",
    type: "EGAME",
  },

  //PP EGAME END

  // AWC Start -----

  // AWC BG Start -----
  {
    img: "../assets/images/Awc/BG-LIVE-001.webp",
    name: "Live Casino BG",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-001",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-002.webp",
    name: "Baccarat",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-002",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-003.webp",
    name: "Roulette Awc",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-003",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-004.webp",
    name: "Sicbo Awc",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-004",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-005.webp",
    name: "Dragon tiger",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-005",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-006.webp",
    name: "Speed Baccarat",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-006",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-007.webp",
    name: "Mi Card Baccarat",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-007",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-008.webp",
    name: "Full Color Baccarat",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-008",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-009.webp",
    name: "BullBull",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-009",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-010.webp",
    name: "Win Three Cards",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-010",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-011.webp",
    name: "RedBlack",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-011",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-012.webp",
    name: "SpeedSicBo",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-012",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-013.webp",
    name: "SeDie",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-013",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-014.webp",
    name: "CasinoWar",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-014",
    cateogry: "BG",
    type: "AWC",
  },
  // AWC BG END -----
  // AWC BTG START -----
  {
    img: "../assets/images/Awc/BTG-SLOT-001.webp",
    name: "Apollo Pays",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-001",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-002.webp",
    name: "Castle of Terror",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-002",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-003.webp",
    name: "Rasputin Megaways",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-003",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-004.webp",
    name: "Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-004",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-005.webp",
    name: "Extra Chilli",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-005",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-006.webp",
    name: "White Rabbit",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-006",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-007.webp",
    name: "Millionaire",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-007",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-008.webp",
    name: "Golden Catch",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-008",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-009.webp",
    name: "Danger High Voltage",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-009",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-010.webp",
    name: "Christmas Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-010",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-011.webp",
    name: "Christmas Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-011",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-012.webp",
    name: "Christmas Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-012",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-013.webp",
    name: "Christmas Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-013",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-014.webp",
    name: "Christmas Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-014",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-015.webp",
    name: "Christmas Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-015",
    cateogry: "BTG",
    type: "AWC",
  },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-016.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-016",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-017.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-017",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-018.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-018",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-019.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-019",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-020.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-020",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-021.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-021",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-022.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-022",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-023.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-023",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-024.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-024",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-025.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-025",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-026.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-026",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-027.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-027",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-028.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-028",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-029.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-029",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-030.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-030",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-031.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-031",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-032.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-032",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-033.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-033",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-034.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-034",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-035.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-035",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-036.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-036",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },

  // {
  //   img: "../assets/images/Awc/BTG-SLOT-038.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-038",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-039.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-039",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-040.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-040",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-041.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-041",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-042.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-042",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-043.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-043",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-044.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-044",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-045.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-045",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-046.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-046",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-047.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-047",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-048.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-048",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-049.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-049",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-050.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-050",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-051.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-051",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-052.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-052",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-053.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-053",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-054.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-054",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-055.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-055",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },

  // // AWC BTG END -----
  // // AWC E1SPORT START -----
  // {
  //   img: "../assets/images/Awc/E1-ESPORTS-001.webp",
  //   name: "E1Sports",
  //   platForm: "E1SPORT",
  //   gameType: "ESPORTS",
  //   casinoType: "E1-ESPORTS-001",
  //   cateogry: "E1SPORT",
  //   type: "AWC",
  // },
  // AWC E1SPORT END -----

  // AWC NLC START -----
  {
    img: "../assets/images/Awc/NLC-SLOT-001.webp",
    name: "Das x Boot",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-001",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-002.webp",
    name: "Mental",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-002",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-003.webp",
    name: "Punk Toilet",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-003",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-004.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-004",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-005.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-005",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-006.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-006",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-007.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-007",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-008.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-008",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-009.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-009",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-010.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-010",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-011.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-011",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-012.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-012",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-013.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-013",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-014.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-014",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-015.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-015",
    cateogry: "NLC",
    type: "AWC",
  },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-016.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-016",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-017.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-017",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-018.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-018",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-019.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-019",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-020.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-020",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-021.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-021",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-022.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-022",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-023.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-023",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-024.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-024",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-025.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-025",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-026.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-026",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-027.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-027",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-028.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-028",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-029.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-029",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-030.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-030",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-031.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-031",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-032.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-032",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-033.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-033",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-034.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-034",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-035.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-035",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-036.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-036",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-037.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-037",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-038.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-038",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-039.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-039",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-040.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-040",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-041.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-041",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-042.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-042",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-043.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-043",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-044.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-044",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-045.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-045",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-046.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-046",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-047.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-047",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-048.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-048",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-049.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-049",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-050.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-050",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-051.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-051",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-052.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-052",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-053.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-053",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-054.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-054",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-055.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-055",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-056.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-056",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-057.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-057",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-058.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-058",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-059.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-059",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-060.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-060",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-061.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-061",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-062.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-062",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-063.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-063",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-064.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-064",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-065.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-065",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-066.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-066",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-067.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-067",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-068.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-068",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-069.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-069",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-070.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-070",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-071.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-071",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-072.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-072",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-073.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-073",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-074.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-074",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-075.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-075",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-076.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-076",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-077.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-077",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-078.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-078",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-079.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-079",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-080.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-080",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-081.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-081",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-082.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-082",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-083.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-083",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-084.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-084",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-085.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-085",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-086.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-086",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-087.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-087",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-088.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-088",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-089.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-089",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-090.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-090",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-091.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-091",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-092.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-092",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-093.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-093",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-094.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-094",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-095.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-095",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // AWC NLC END -----
  // AWC RT START -----
  {
    img: "../assets/images/Awc/RT-SLOT-001.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-001",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-002.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-002",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-003.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-003",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-004.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-004",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-005.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-005",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-006.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-006",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-007.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-007",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-008.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-008",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-009.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-009",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-010.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-010",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-011.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-011",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-012.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-012",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-013.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-013",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-014.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-014",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-015.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-015",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-016.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-016",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-017.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-017",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-018.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-018",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-019.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-019",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-020.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-020",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-021.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-021",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-022.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-022",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-023.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-023",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-024.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-024",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-025.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-025",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-026.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-026",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-027.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-027",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-028.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-028",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-029.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-029",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-030.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-030",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-031.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-031",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-032.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-032",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-033.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-033",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-034.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-034",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-035.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-035",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-036.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-036",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-037.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-037",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-038.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-038",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-039.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-039",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-040.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-040",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-041.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-041",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-042.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-042",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-043.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-043",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-044.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-044",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-045.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-045",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-046.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-046",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-047.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-047",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-048.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-048",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-049.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-049",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-050.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-050",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-051.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-051",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-052.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-052",
    cateogry: "RT",
    type: "AWC",
  },
  // AWC RT END -----
  // AWC SV388 START -----

  {
    img: "../assets/images/Awc/SV-LIVE-001.webp",
    name: "SV388",
    platForm: "SV388",
    gameType: "LIVE",
    casinoType: "SV-LIVE-001",
    cateogry: "SV388",
    type: "AWC",
  },
  // AWC SV388 END -----
  // AWC YESBINGO START -----
  {
    img: "../assets/images/Awc/YesBingo-BINGO-001.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-001",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-002.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-002",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-003.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-003",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-004.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-004",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-005.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-005",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-006.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-006",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-007.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-007",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-008.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-008",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-009.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-009",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-010.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-010",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-011.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-011",
    cateogry: "YesBingo",
    type: "AWC",
  },

  {
    img: "../assets/images/Awc/YesBingo-FH-001.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "FH",
    casinoType: "YesBingo-FH-001",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-001.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-001",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-002.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-002",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-003.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-003",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-004.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-004",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-005.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-005",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-006.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-006",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-007.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-007",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-008.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-008",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-009.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-009",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-010.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-010",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-011.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-011",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-012.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-012",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-013.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-013",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-014.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-014",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-015.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-015",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-016.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-016",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-017.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-017",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-018.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-018",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-019.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-019",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-020.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-020",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-021.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-021",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-022.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-022",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-023.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-023",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-024.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-024",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-025.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-025",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-026.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-026",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-027.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-027",
    cateogry: "YesBingo",
    type: "AWC",
  },

  {
    img: "../assets/images/Awc/YesBingo-SLOT-029.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-029",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-030.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-030",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-031.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-031",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-EGAME-001.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "EGAME",
    casinoType: "YesBingo-EGAME-001",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-EGAME-002.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "EGAME",
    casinoType: "YesBingo-EGAME-002",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-EGAME-003.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "EGAME",
    casinoType: "YesBingo-EGAME-003",
    cateogry: "YesBingo",
    type: "AWC",
  },
  // AWC YESBINGO END -----
  // AWC YL START -----
  {
    img: "../assets/images/Awc/YL-EGAME-001.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-001",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-002.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-002",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-003.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-003",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-004.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-004",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-005.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-005",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-006.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-006",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-007.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-007",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-008.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-008",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-009.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-009",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-010.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-010",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-011.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-011",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-012.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-012",
    cateogry: "YL",
    type: "AWC",
  },
  // AWC YL END -----
  // AWC End -----
  // ---- New games synced from reference ----
  {
    img: "../assets/images/Awc/BG-LIVE-001.webp",
    name: "Live Casino BG",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-001",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-002.webp",
    name: "Baccarat",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-002",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-003.webp",
    name: "Roulette Awc",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-003",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-004.webp",
    name: "Sicbo Awc",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-004",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-005.webp",
    name: "Dragon tiger",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-005",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-006.webp",
    name: "Speed Baccarat",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-006",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-007.webp",
    name: "Mi Card Baccarat",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-007",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-008.webp",
    name: "Full Color Baccarat",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-008",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-009.webp",
    name: "BullBull",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-009",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-010.webp",
    name: "Win Three Cards",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-010",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-011.webp",
    name: "RedBlack",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-011",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-012.webp",
    name: "SpeedSicBo",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-012",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-013.webp",
    name: "SeDie",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-013",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-014.webp",
    name: "CasinoWar",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-014",
    cateogry: "BG",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA002.png",
    name: "Classic Baccarat",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-001",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA004.png",
    name: "Speed Baccarat",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-002",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA004.png",
    name: "Lucky Natural",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-003",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA005.png",
    name: "Pair Baccarat",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-004",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA006.png",
    name: "Wealth SuperSix",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-005",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA007.png",
    name: "Dragon Tiger",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-006",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA008.png",
    name: "Classic Sic Bo",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-007",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA009.png",
    name: "Thai Hi Lo",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-008",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA010.png",
    name: "Tai Xiu",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-009",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA011.png",
    name: "Color Game",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-010",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA012.png",
    name: "Thai Fish Prawn Crab",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-011",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA013.png",
    name: "Viet Fish Prawn Crab",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-012",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA014.png",
    name: "Xoc Dia",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-015",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA015.png",
    name: "Blockchain Classic Sic Bo",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-017",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA017.png",
    name: "Blockchain Tai Xiu",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-019",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA018.png",
    name: "Lotto Lucky Natural",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-022",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA019.png",
    name: "Lotto Xoc Dia",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-023",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA020.png",
    name: "Lotto Lucky Wheel",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-024",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA024.png",
    name: "Crazy Marbles",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-025",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA025.png",
    name: "Tornado Marbles",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-026",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA026.png",
    name: "Blockchain Thai FishShrimpCrab",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-027",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA027.png",
    name: "Blockchain Viet FishShrimpCrab",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-028",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA028.png",
    name: "Blockchain Xoc Dia",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-029",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA029.png",
    name: "Blockchain Color Game",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-030",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA030.png",
    name: "Rocket HiLo Baccarat",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-016",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA031.png",
    name: "BlockchainThai Hi Lo",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-018",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA032.png",
    name: "Lotto Baccarat",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-020",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/VIA033.png",
    name: "Lotto Super Six",
    platForm: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-021",
    cateogry: "VIACASINO",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Bar BJ 5.webp",
    name: "Bar Black Jack 5",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-001",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Venice BJ 4.webp",
    name: "Venice Black Jack 4",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-002",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Venice BJ 2.webp",
    name: "Venice Black Jack 2 (Private)",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-003",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Bar Roulette 2000X.webp",
    name: "Bar Roulette 2000X",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-004",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Venice Roulette.webp",
    name: "Venice Roulette",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-005",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Auto Roulette.webp",
    name: "Auto Roulette",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-006",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/500X Auto Roulette.webp",
    name: "500X Auto Roulette",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-007",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/VIP Auto Roulette.webp",
    name: "VIP Auto Roulette",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-008",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/BigBang Roulette.webp",
    name: "Big Bang Roulette",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-009",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Tao Yuan Baccarat 1.webp",
    name: "Tao Yuan Baccarat 1",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-010",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Tao Yuan Baccarat 2.webp",
    name: "Tao Yuan Baccarat 2",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-011",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Tao Yuan Baccarat 5.webp",
    name: "Tao Yuan Baccarat 5",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-012",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Tao Yuan Baccarat 6.webp",
    name: "Tao Yuan Baccarat 6",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-013",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Tao Yuan Baccarat 7.webp",
    name: "Tao Yuan Baccarat 7",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-014",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Tao Yuan Baccarat 8.webp",
    name: "Tao Yuan Baccarat 8",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-015",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Shangrila Baccarat 5.webp",
    name: "Shangrila Baccarat 5",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-016",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Shangrila Baccarat 6.webp",
    name: "Shangrila Baccarat 6",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-017",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Dragon Tiger.webp",
    name: "Dragon Tiger",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-018",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Cabaret Roulette.webp",
    name: "Cabaret Roulette",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-019",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Top Card.webp",
    name: "Top Card",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-020",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Bar BJ 5.webp",
    name: "Bar Black Jack 3",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-026",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Bar BJ 5.webp",
    name: "Bar Black Jack 4",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-027",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Shangrila 7.webp",
    name: "Shangrila Baccarat 7",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-028",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Shangrila 8.webp",
    name: "Shangrila Baccarat 8",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-029",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Hanguk Auto Roulette.webp",
    name: "Hanguk Auto Roulette",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-030",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Agent Spinity.webp",
    name: "Agent Spinity",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-031",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Tao Yuan Baccarat 3.webp",
    name: "Tao Yuan Baccarat 3",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-032",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Sic Bo.webp",
    name: "Sic Bo",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-033",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Andar Bahar.webp",
    name: "Andar Bahar",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-034",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Andar Bahar x5000.webp",
    name: "Andar Bahar x5000",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-035",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Monaco Blackjack 1.webp",
    name: "Monaco Blackjack 1",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-036",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Monaco Blackjack 2.webp",
    name: "Monaco Blackjack 2",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-037",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Monaco Blackjack 3.webp",
    name: "Monaco Blackjack 3",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-038",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Monaco Blackjack 4.webp",
    name: "Monaco Blackjack 4",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-039",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Monaco Blackjack 5.webp",
    name: "Monaco Blackjack 5",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-040",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Monaco VIP Blackjack 6.webp",
    name: "Monaco VIP Blackjack 6",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-041",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Venice INSTANT Roulette.webp",
    name: "Venice INSTANT Roulette",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-042",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Symphony Blackjack 1.webp",
    name: "Symphony Blackjack 1",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-043",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Symphony Blackjack 2.webp",
    name: "Symphony Blackjack 2",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-044",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/BigBang Roulette.webp",
    name: "BigBang INSTANT Roulette",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-045",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Bar Instant Blackjack.webp",
    name: "Bar Instant Blackjack",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-046",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Le Rouge 2.webp",
    name: "Le Rouge Blackjack 2",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-047",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Monaco Instant Blackjack.webp",
    name: "Monaco Instant Blackjack",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-048",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/winfinity/Le Rouge 1.webp",
    name: " Le Rouge Blackjack 1 ",
    platForm: "WINFINITY",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-049",
    cateogry: "WINFINITY",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Speed Baccarat D.png",
    name: "Speed Baccarat D",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-001",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Speed Baccarat E.png",
    name: "Speed Baccarat E",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-002",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Korean Baccarat.png",
    name: "Korean Baccarat",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-003",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Roulette A.png",
    name: "Roulette A",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-005",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Auto Roulette.png",
    name: "Auto Roulette",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-006",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Auto Roulette Speed.png",
    name: "Auto Roulette Speed",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-007",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Roulette Armenian.png",
    name: "Roulette Armenian",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-008",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Roulette Brasileira.png",
    name: "Roulette Brasileira",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-009",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Roulette Turkish.png",
    name: "Roulette Turkish",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-010",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Roulette Persian.png",
    name: "Roulette Persian",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-011",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Roulette Arabic.png",
    name: "Roulette Arabic",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-013",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Roulette PopOK.png",
    name: "Roulette PopOK",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-015",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Roulette Speed.png",
    name: "Roulette Speed",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-016",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Bet On Poker.png",
    name: "Bet On Poker",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-018",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Russian Poker A.png",
    name: "Russian Poker A",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-019",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Keno LIVE.png",
    name: "Keno LIVE",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-020",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Sic Bo.png",
    name: "Sic Bo",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-021",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Baccarat Classic.png",
    name: "Baccarat Classic",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-022",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Dragon Tiger.png",
    name: "Dragon Tiger",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-023",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Casino Holdem.png",
    name: "Casino Holdem",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-027",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Swift Roulette 8 IN ONE.png",
    name: "Swift Roulette 8 IN ONE",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-029",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Andar Bahar A.png",
    name: "Andar Bahar A",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-030",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/Teen Patti.png",
    name: "Teen Patti",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-031",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/BlackJack Atrium A.png",
    name: "BlackJack Atrium A",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-032",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/BlackJack Atrium B.png",
    name: "BlackJack Atrium B",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-033",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/BlackJack Creed P.png",
    name: "BlackJack Creed P",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-034",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/BlackJack Persian D.png",
    name: "BlackJack Persian D",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-037",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/BlackJack Premium.png",
    name: "BlackJack Premium",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-038",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/BlackJack Turkish B.png",
    name: "BlackJack Turkish B",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-039",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/BlackJack Turkish C.png",
    name: "BlackJack Turkish C",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-040",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/BlackJack VIP A.png",
    name: "BlackJack VIP A",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-041",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/live_casino/creedroomz/BlackJack VIP B.png",
    name: "BlackJack VIP B",
    platForm: "CREEDROOMZ",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-042",
    cateogry: "CREEDROOMZ",
    type: "GAME-SHOWS",
  },
  {
    img: "/dataImages/table/jdb/PUSOY.png",
    name: "PUSOY ",
    platForm: "JDB",
    gameType: "TABLE",
    casinoType: "JDB-TABLE-001",
    cateogry: "JDB",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/jdb/TONGITS.png",
    name: "TONGITS",
    platForm: "JDB",
    gameType: "TABLE",
    casinoType: "JDB-TABLE-002",
    cateogry: "JDB",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/jdb/TONGITS FIGHT.png",
    name: "TONGITS FIGHT",
    platForm: "JDB",
    gameType: "TABLE",
    casinoType: "JDB-TABLE-003",
    cateogry: "JDB",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/jdb/PUSOY RUSH.png",
    name: "PUSOY RUSH",
    platForm: "JDB",
    gameType: "TABLE",
    casinoType: "JDB-TABLE-004",
    cateogry: "JDB",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/jdb/Teen Patti 20-20.png",
    name: "Teen Patti 20-20",
    platForm: "JDB",
    gameType: "TABLE",
    casinoType: "JDB-TABLE-007",
    cateogry: "JDB",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/jdb/Rummy.png",
    name: "Rummy",
    platForm: "JDB",
    gameType: "TABLE",
    casinoType: "JDB-TABLE-009",
    cateogry: "JDB",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/jdb/Andar Bahar.png",
    name: "Andar Bahar",
    platForm: "JDB",
    gameType: "TABLE",
    casinoType: "JDB-TABLE-010",
    cateogry: "JDB",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/jdb/Pusoy Go.png",
    name: "Pusoy Go",
    platForm: "JDB",
    gameType: "TABLE",
    casinoType: "JDB-TABLE-011",
    cateogry: "JDB",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/jdb/Tongits Go.png",
    name: "Tongits Go",
    platForm: "JDB",
    gameType: "TABLE",
    casinoType: "JDB-TABLE-012",
    cateogry: "JDB",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/PG/BaccaratDeluxe.png",
    name: "Baccarat Deluxe",
    platForm: "PG",
    gameType: "TABLE",
    casinoType: "PG-TABLE-001",
    cateogry: "PG",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/rt/Punto Banco.png",
    name: "Punto Banco",
    platForm: "RT",
    gameType: "TABLE",
    casinoType: "RT-TABLE-001",
    cateogry: "RT",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/rt/European Roulette.png",
    name: "European Roulette",
    platForm: "RT",
    gameType: "TABLE",
    casinoType: "RT-TABLE-002",
    cateogry: "RT",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Royal Gaming Live Lobby.webp",
    name: "Royal Gaming Live Lobby",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-001",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/7 Up Down.webp",
    name: "7 Up Down",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-002",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Teen Patti.webp",
    name: "Teen Patti",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-003",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Dragon Tiger.webp",
    name: "Dragon Tiger",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-004",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Cricket War.webp",
    name: "Cricket War",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-005",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Baccarat.webp",
    name: "Baccarat",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-006",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Amar Akbar Anthony.webp",
    name: "Amar Akbar Anthony",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-007",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/3 Cards Judgement.webp",
    name: "3 Cards Judgement",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-008",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Worli Matka.webp",
    name: "Worli Matka",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-009",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Lottery.webp",
    name: "Lottery",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-010",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/HighLow.webp",
    name: "HighLow",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-011",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Muflis Teen Patti.webp",
    name: "Muflis Teen Patti",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-012",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/One Day Teenpatti.webp",
    name: "One Day Teenpatti",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-013",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Lucky7.webp",
    name: "Lucky7",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-014",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Akbar Romeo Walter.webp",
    name: "Akbar Romeo Walter",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-015",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/2 Cards Teenpatti.webp",
    name: "2 Cards Teenpatti",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-016",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Dragon Tiger One day.webp",
    name: "Dragon Tiger One day",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-017",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Dragon Tiger Lion.webp",
    name: "Dragon Tiger Lion",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-018",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Trio.webp",
    name: "Trio",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-019",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/2 Card Teen Patti One Day.webp",
    name: "2 Card Teen Patti One Day",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-020",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Center Card.webp",
    name: "Center Card",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-021",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Instant Teenpatti 2.webp",
    name: "Instant Teenpatti 2",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-023",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Roulette Classic.webp",
    name: "Roulette Classic",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-024",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Diamond Roulette.webp",
    name: "Diamond Roulette",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-025",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Diamond Teen Patti.webp",
    name: "Diamond Teen Patti",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-026",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Speed Auto Roulette.webp",
    name: "Speed Auto Roulette",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-027",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Auto Roulette A.webp",
    name: "Auto Roulette A",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-028",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Auto Roulette.webp",
    name: "Auto Roulette",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-029",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/VIP TeenPatti.webp",
    name: "VIP TeenPatti",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-033",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Casino War.webp",
    name: "Casino War",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-034",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/Bollywood Casino.webp",
    name: "Bollywood Casino",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-035",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/table/royalgaming/20-20 Cricket.webp",
    name: "20-20 Cricket",
    platForm: "ROYALGAMING",
    gameType: "LIVE",
    casinoType: "RG-LIVE-036",
    cateogry: "ROYALGAMING",
    type: "TABLE",
  },
  {
    img: "/dataImages/slots/PG0002.png",
    name: "Honey Trap of Diao Chan",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-001",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0014.png",
    name: "Gem Saviour",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-002",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0003.png",
    name: "Fortune Gods",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-003",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0009.png",
    name: "Medusa",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-006",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0017.png",
    name: "Hood vs Wolf",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-009",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0004.png",
    name: "Win Win Won",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-011",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0012.png",
    name: "Plushie Frenzy",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-012",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0007.png",
    name: "Tree of Fortune",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-013",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0018.png",
    name: "Hotpot",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-015",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0019.png",
    name: "Dragon Legend",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-016",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0024.png",
    name: "Hip Hop Panda",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-017",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0021.png",
    name: "Legend of Hou Yi",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-018",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0020.png",
    name: "Mr. Hallow-Win",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-019",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0023.png",
    name: "Prosperity Lion",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-020",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0027.png",
    name: "Gem Saviour Sword",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-022",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0028.png",
    name: "Piggy Gold",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-023",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0033.png",
    name: "Jungle Delight",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-024",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0029.png",
    name: "Symbols of Egypt",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-025",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0031.png",
    name: "Ganesha Gold",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-026",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0035.png",
    name: "Double Fortune",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-030",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0037.png",
    name: "The Great Icescape",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-032",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0045.png",
    name: "Dragon Tiger Luck",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-035",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0042.png",
    name: "Flirting Scholar",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-036",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0041.png",
    name: "Leprechaun Riches",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-038",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0044.png",
    name: "Muay Thai Champion",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-039",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0043.png",
    name: "Ninja vs Samurai",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-040",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0046.png",
    name: "Mahjong Ways",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-041",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0047.png",
    name: "Dragon Hatch",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-042",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0048.png",
    name: "Fortune Mouse",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-043",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0049.png",
    name: "Reel Love",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-044",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0051.png",
    name: "Gem Saviour Conquest",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-045",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0050.png",
    name: "Shaolin Soccer",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-046",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0052.png",
    name: "Caishen Wins",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-047",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0053.png",
    name: "Candy Burst",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-048",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0054.png",
    name: "Bikini Paradise",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-049",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0055.png",
    name: "Mahjong Ways 2",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-050",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0056.png",
    name: "Egypt's Book of Mystery",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-051",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0057.png",
    name: "Ganesha Fortune",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-052",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0059.png",
    name: "Phoenix Rises",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-053",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0063.png",
    name: "Wild Fireworks",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-055",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0065.png",
    name: "Genie's 3 Wishes",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-057",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0066.png",
    name: "Treasures of Aztec",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-058",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0067.png",
    name: "Circus Delight",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-059",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0068.png",
    name: "Thai River Wonders",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-060",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0069.png",
    name: "Secret of Cleopatra",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-061",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0070.png",
    name: "Vampire's Charm",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-062",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0072.png",
    name: "Jewels of Prosperity",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-064",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0073.png",
    name: "Lucky Neko",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-065",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0074.png",
    name: "Jack Frost's Winter",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-066",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0075.png",
    name: "Galactic Gems",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-067",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0076.png",
    name: "Guardians of Ice and Fire",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-068",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0077.png",
    name: "Opera Dynasty",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-069",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0078.png",
    name: "Fortune Ox",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-070",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0079.png",
    name: "Bali Vacation",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-071",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0080.png",
    name: "Crypto Gold",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-072",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0081.png",
    name: "Majestic Treasures",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-073",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0082.png",
    name: "Candy Bonanza",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-074",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0083.png",
    name: "Wild Bandito",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-075",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0086.png",
    name: "Rise of Apollo",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-078",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0088.png",
    name: "Jurassic Kingdom",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-079",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0089.png",
    name: "Mermaid Riches",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-081",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0091.png",
    name: "Raider Jane's Crypt of Fortune",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-083",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0092.png",
    name: "Supermarket Spree",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-084",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0093.png",
    name: "Buffalo Win",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-085",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0094.png",
    name: "Legendary Monkey King",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-086",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0095.png",
    name: "Spirited Wonders",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-087",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0097.png",
    name: "Emoji Riches",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-089",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0098.png",
    name: "Cocktail Nights",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-090",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0099.png",
    name: "Mask Carnival",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-091",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0100.png",
    name: "Oriental Prosperity",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-092",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0101.png",
    name: "Fortune Tiger",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-093",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0102.png",
    name: "Garuda Gems",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-094",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0104.png",
    name: "Butterfly Blossom",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-096",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0105.png",
    name: "Rooster Rumble",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-097",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0106.png",
    name: "The Queen's Banquet",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-098",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0107.png",
    name: "Battleground Royale",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-099",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0108.png",
    name: "Win Win Fish Prawn Crab",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-100",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0109.png",
    name: "Lucky Piggy",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-101",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0110.png",
    name: "Speed Winner",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-102",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0111.png",
    name: "Legend of Perseus",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-103",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0112.png",
    name: "Wild Coaster",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-104",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0113.png",
    name: "Wild Bounty Showdown",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-105",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0114.png",
    name: "Prosperity Fortune Tree",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-106",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0115.png",
    name: "Totem Wonders",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-107",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0116.png",
    name: "Alchemy Gold",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-108",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0117.png",
    name: "Diner Delights",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-109",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0118.png",
    name: "Asgardian Rising",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-110",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0119.png",
    name: "Midas Fortune",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-111",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0120.png",
    name: "Fortune Rabbit",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-112",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0121.png",
    name: "Rave Party Fever",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-113",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0122.png",
    name: "Hawaiian Tiki",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-114",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0123.png",
    name: "Bakery Bonanza",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-115",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0124.png",
    name: "Songkran Splash",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-116",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0125.png",
    name: "Mystical Spirits",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-117",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0126.png",
    name: "Super Golf Drive",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-118",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0127.png",
    name: "Lucky Clover Riches",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-119",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0129.png",
    name: "Cruise Royale",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-121",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0130.png",
    name: "Safari Wilds",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-122",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0131.png",
    name: "Gladiator's Glory",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-123",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0132.png",
    name: "Ninja Raccoon Frenzy",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-124",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0133.png",
    name: "Ultimate Striker",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-125",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0134.png",
    name: "Wild Heist Cashout",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-126",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0135.png",
    name: "Forge of Wealth",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-127",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0136.png",
    name: "Mafia Mayhem",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-128",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0137.png",
    name: "Tsar Treasures",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-129",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0138.png",
    name: "Werewolf's Hunt",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-130",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0139.png",
    name: "Dragon Hatch 2",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-131",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0140.png",
    name: "Fortune Dragon",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-132",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0141.png",
    name: "Gemstones Gold",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-133",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0142.png",
    name: "Cash Mania",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-134",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0144.png",
    name: "Pinata Wins",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-136",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0145.png",
    name: "Mystic Potion",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-137",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0146.png",
    name: "Anubis Wrath",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-138",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0148.png",
    name: "Zombie Outbreak",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-139",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0147.png",
    name: "Chicky Run",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-140",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0149.png",
    name: "Futebol Fever",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-141",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0150.png",
    name: "Shark Bounty",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-142",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0151.png",
    name: "Yakuza Honor",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-143",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0152.png",
    name: "Wings of Iguazu",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-144",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0153.png",
    name: "Three Crazy Piggies",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-145",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0154.png",
    name: "Oishi Delights",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-146",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0155.png",
    name: "Museum Wonders",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-147",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0156.png",
    name: "Rio Fantasia",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-148",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0157.png",
    name: "Chocolate Deluxe",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-149",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0158.png",
    name: "Geisha's Revenge",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-150",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0159.png",
    name: "Fortune Snake",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-151",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0160.png",
    name: "Incan Wonders",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-152",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0162.png",
    name: "Graffiti Rush",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-154",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0163.png",
    name: "Doomsday Rampage",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-155",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0164.png",
    name: "Knockout Riches",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-156",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0165.png",
    name: "Dead Man's Riches",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-157",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0166.png",
    name: "Jack the Giant Hunter",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-158",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0167.png",
    name: "Diner Frenzy Spins",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-159",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0168.png",
    name: "Dragon's Treasure Quest",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-160",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0169.png",
    name: "Galaxy Miner",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-161",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/PG0170.png",
    name: "Grimms' Bounty: Hansel & Gretel",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-162",
    cateogry: "PG",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0008.png",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-001",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0010.png",
    name: "Arcade Bomb",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-002",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0015.png",
    name: "Blue Diamond",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-003",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0020.png",
    name: "Chinese Treasures",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-004",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0021.png",
    name: "Cinderella's Ball",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-005",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0024.png",
    name: "Crazy Genie",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-006",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0027.png",
    name: "Devil's Number",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-007",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0030.png",
    name: "Divine Ways",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-008",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0031.png",
    name: "Dragon's Fire",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-009",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0034.png",
    name: "Dragon's Luck",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-010",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0037.png",
    name: "Dragon's Luck Power Reels",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-011",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0040.png",
    name: "Elven Magic",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-012",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0041.png",
    name: "Emerald Diamond",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-013",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0042.png",
    name: "Epic Journey",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-014",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0043.png",
    name: "Esqueleto Mariachi",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-015",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0044.png",
    name: "Five Star",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-016",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0045.png",
    name: "Five Star Power Reels",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-017",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0046.png",
    name: "Flaming Fox",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-018",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0047.png",
    name: "Fortune Charm",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-019",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0048.png",
    name: "Fortune Fest",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-020",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0049.png",
    name: "Fortune House",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-021",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0050.png",
    name: "Fruit Blox",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-022",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0052.png",
    name: "Gems Gone Wild",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-023",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0054.png",
    name: "Gemtastic",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-024",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0055.png",
    name: "God Of Wealth",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-025",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0056.png",
    name: "Gold Star",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-026",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0059.png",
    name: "Golden Lotus",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-027",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0060.png",
    name: "Golden Offer",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-028",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0064.png",
    name: "Grand Wheel",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-029",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0066.png",
    name: "Imperial Palace",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-030",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0067.png",
    name: "Jack In A Pot",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-031",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0068.png",
    name: "Jackpot Quest",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-032",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0069.png",
    name: "Jade Charms",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-033",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0070.png",
    name: "Jester Spins",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-034",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0072.png",
    name: "Jingle Bells",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-035",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0074.png",
    name: "Laser Fruit",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-036",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0077.png",
    name: "Lion Dance",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-037",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0078.png",
    name: "Lucky Easter",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-038",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0079.png",
    name: "Lucky Fortune Cat",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-039",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0081.png",
    name: "Lucky Halloween",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-040",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0084.png",
    name: "Lucky Valentine",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-041",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0085.png",
    name: "Lucky Wizard",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-042",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0086.png",
    name: "Magic Gate",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-043",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0087.png",
    name: "Masquerade",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-044",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0088.png",
    name: "Mayan Gods",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-045",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0090.png",
    name: "Mega Jade",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-046",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0091.png",
    name: "Mega Pyramid",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-047",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0092.png",
    name: "Mega Rise",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-048",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0093.png",
    name: "Midas Gold",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-049",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0095.png",
    name: "Mystery Reels",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-050",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0098.png",
    name: "Mystic Wheel",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-052",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0099.png",
    name: "Ninja Ways",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-053",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0100.png",
    name: "Ocean Fortune",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-054",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0102.png",
    name: "Persian Fortune",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-055",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0104.png",
    name: "Phoenix Fire Power Reels",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-056",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0105.png",
    name: "Piggy Pirates",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-057",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0109.png",
    name: "Puss'n Boots",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-059",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0111.png",
    name: "Rainbow Jackpots",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-060",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0110.png",
    name: "Ra's Legend",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-061",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0113.png",
    name: "Reactor",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-062",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0114.png",
    name: "Red Diamond",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-063",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0103.png",
    name: "Phoenix",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-064",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0115.png",
    name: "Reel Heist",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-065",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0122.png",
    name: "Rocket Men",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-066",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0123.png",
    name: "Royal Gems",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-067",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0124.png",
    name: "Snow Wild And The 7 Features",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-068",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0125.png",
    name: "Spin Town",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-069",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0126.png",
    name: "Stage 888",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-070",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0127.png",
    name: "Sumo Spins",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-071",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0061.png",
    name: "Golden Temple",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-072",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0129.png",
    name: "Ten Elements",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-073",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0130.png",
    name: "The Equalizer",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-074",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0131.png",
    name: "The Greatest Train Robbery",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-075",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0133.png",
    name: "Thor's Lightning",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-076",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0136.png",
    name: "Three Musketeers",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-077",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0137.png",
    name: "Tiki Fruits",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-078",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0138.png",
    name: "Totem Lightning",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-079",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0139.png",
    name: "Totem Lightning Power Reels",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-080",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0140.png",
    name: "Treasure Mine",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-081",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0144.png",
    name: "Vicky Ventura",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-082",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0148.png",
    name: "Wild Circus",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-083",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0150.png",
    name: "Wild Fight",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-084",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0151.png",
    name: "Wild Nords",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-085",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0153.png",
    name: "Wild Spartans",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-086",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0154.png",
    name: "Wild Wild Chest",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-087",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0157.png",
    name: "Winter Wonders",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-088",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0013.png",
    name: "Aztec Spins",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-089",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0019.png",
    name: "Cash Volt",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-090",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0038.png",
    name: "Dynamite Riches",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-093",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0051.png",
    name: "Fruit Snap",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-094",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0057.png",
    name: "Golden Cryptex",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-095",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0354.png",
    name: "Leprechaun's Magic",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-096",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0108.png",
    name: "Pirates' Plenty Battle for Gold",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-097",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0112.png",
    name: "Rainbow Jackpots Power Lines",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-098",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0121.png",
    name: "Rio Stars",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-099",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0143.png",
    name: "Vault Of Anubis",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-100",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0147.png",
    name: "Wild Cats Multiline",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-101",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0199.png",
    name: "Zillard King",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-102",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0345.png",
    name: "Dragon Pearl",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-121",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0018.png",
    name: "Cash Ultimate",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-123",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0017.png",
    name: "Bounty Raid",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-124",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0101.png",
    name: "Path of Destiny",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-125",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0094.png",
    name: "Multiplier Riches",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-126",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0029.png",
    name: "Dice Dice Dice",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-127",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0177.png",
    name: "Shah Mat",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-128",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0227.png",
    name: "Cake and Ice Cream",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-129",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0117.png",
    name: "Reel King Mega",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-130",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0180.png",
    name: "Age Of Akkadia",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-131",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0201.png",
    name: "Viral Spiral",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-132",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0028.png",
    name: "Diamond Blitz",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-133",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0025.png",
    name: "Crystal Mirror",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-134",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0164.png",
    name: "Mystic Staxx",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-135",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0186.png",
    name: "Hammer Gods",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-136",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0234.png",
    name: "Peggy Sweets",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-137",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0119.png",
    name: "Regal Streak",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-138",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0222.png",
    name: "Tricks and Treats",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-139",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0107.png",
    name: "Pirates' Plenty",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-140",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0156.png",
    name: "Wings Of Ra",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-141",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0016.png",
    name: "Bombuster",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-143",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0022.png",
    name: "Cirque Dе La Fortune",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-144",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0023.png",
    name: "Clash of the Beasts",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-145",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0026.png",
    name: "Da Vinci's Mystery",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-146",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0039.png",
    name: "Eagle Riches",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-147",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0053.png",
    name: "Gems Gone Wild Power Reels",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-148",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0062.png",
    name: "Golden Tsar",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-150",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0065.png",
    name: "Hoard of Poseidon",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-152",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0071.png",
    name: "Jewel Scarabs",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-153",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0073.png",
    name: "Jingle Bells Power Reels",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-154",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0076.png",
    name: "Legendary Excalibur",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-155",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0080.png",
    name: "Lucky Fridays",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-156",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0083.png",
    name: "Lucky Oktoberfest",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-157",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0097.png",
    name: "Mystery Reels Power Reels",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-158",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0116.png",
    name: "Reel Keeper",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-160",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0118.png",
    name: "Regal Beasts",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-161",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0120.png",
    name: "Riddle Of The Sphinx",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-162",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0128.png",
    name: "Sylvan Spirits",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-163",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0132.png",
    name: "The Wild Hatter",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-164",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0134.png",
    name: "Thor's Vengeance",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-165",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0141.png",
    name: "Trillionaire",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-166",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0142.png",
    name: "Vault Cracker",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-167",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0145.png",
    name: "War of Gods",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-168",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0146.png",
    name: "Well Of Wishes",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-169",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0158.png",
    name: "Yucatan's Mystery",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-170",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0191.png",
    name: "Jingle Ways Megaways™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-171",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0192.png",
    name: "Blazing Clusters",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-172",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0193.png",
    name: "Hustling",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-173",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0195.png",
    name: "Fa Fa Babies",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-175",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0196.png",
    name: "Last Chance Saloon",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-176",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0197.png",
    name: "Doggy Riches Megaways™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-177",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0198.png",
    name: "Genie Nights",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-178",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0202.png",
    name: "Cash or Nothing",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-179",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0204.png",
    name: "Bulls Run Wild",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-180",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0205.png",
    name: "Mayhem",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-181",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0206.png",
    name: "Big Cat Rescue Megaways™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-182",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0207.png",
    name: "Diamond Royale",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-183",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0208.png",
    name: "Flodder",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-184",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0209.png",
    name: "Risque Megaways™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-185",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0210.png",
    name: "Zaida's Fortune",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-186",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0211.png",
    name: "Apache Way",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-187",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0212.png",
    name: "Majestic Mysteries Power Reels™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-188",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0215.png",
    name: "Wild Tundra",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-189",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0217.png",
    name: "Bass Boss",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-190",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0218.png",
    name: "Rock'n'Lock",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-191",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0219.png",
    name: "Gonzita's Quest",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-192",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0220.png",
    name: "Great Gold",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-193",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0221.png",
    name: "Mystery Reels Deluxe",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-194",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0155.png",
    name: "Win Escalator",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-195",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0082.png",
    name: "Lucky Little Devil",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-196",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0135.png",
    name: "Three Kingdoms",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-197",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0149.png",
    name: "Wild Elements",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-198",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0152.png",
    name: "Wild O'Clock",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-199",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0162.png",
    name: "Harle Coin",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-200",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0163.png",
    name: "Joe Exotic",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-201",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0165.png",
    name: "Night Roller",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-202",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0167.png",
    name: "Primate King",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-203",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0169.png",
    name: "Reptizillions Power Reels",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-204",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0170.png",
    name: "Tiki Fruits Totem Frenzy",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-205",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0172.png",
    name: "Neon Links",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-207",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0173.png",
    name: "Wild Hot Chilli Reels",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-208",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0174.png",
    name: "The Wisecracker Lightning",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-209",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0175.png",
    name: "Treasure Mine Power Reels™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-210",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0176.png",
    name: "NFT Megaways™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-211",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0178.png",
    name: "Dynamite Riches MW + PowerWheel",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-212",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0183.png",
    name: "Lion's Hoard",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-215",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0184.png",
    name: "Fortune House Power Reels™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-216",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0185.png",
    name: "Beriched",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-217",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0187.png",
    name: "Wild Expedition",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-218",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0188.png",
    name: "Hot Hot Chilli Pot",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-219",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0189.png",
    name: "Dracula Awakening",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-220",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0190.png",
    name: "1942: Sky Warrior",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-221",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0200.png",
    name: "Narcos Mexico",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-222",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0214.png",
    name: "Robin Hood's Wild Forest",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-223",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0223.png",
    name: "Stolen Treasures",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-224",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0224.png",
    name: "Shadow Society",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-225",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0226.png",
    name: "In the Rabbit Hole",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-227",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0229.png",
    name: "Good Luck Clusterbuster™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-228",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0230.png",
    name: "Pinatas & Ponies",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-229",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0231.png",
    name: "Cai Shen 168",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-230",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0232.png",
    name: "Blood Suckers™ Megaways™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-231",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0233.png",
    name: "Ancient Disco",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-232",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0237.png",
    name: "Bugsy's Bar",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-235",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0238.png",
    name: "Happy Apples",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-236",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0239.png",
    name: "Transylvanian: Night of Blood",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-237",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0240.png",
    name: "Wrigley's World",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-238",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0241.png",
    name: "Sheep Gone Wild",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-239",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0242.png",
    name: "Reel Keeper Power Reels",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-240",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0360.png",
    name: "Red Hot BBQ",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-241",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0359.png",
    name: "Magic Powers Megaways",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-242",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0353.png",
    name: "Knights Of Avalon",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-243",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0363.png",
    name: "Wolfkin",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-244",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0336.png",
    name: "Ali Baba's Luck",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-247",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0432.png",
    name: "Christmas Morning",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-250",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0436.png",
    name: "Christmas MULTIHOPS",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-251",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0434.png",
    name: "Sea Boat Adventure",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-252",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0463.png",
    name: "Astronaut",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-253",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0451.png",
    name: "Bounty Raid 2",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-254",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0449.png",
    name: "Case Closed",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-255",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0447.png",
    name: "Easy Gold",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-258",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0453.png",
    name: "Here Kitty Kitty",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-262",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0457.png",
    name: "London Tube",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-264",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0459.png",
    name: "Magic Tricks",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-265",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0455.png",
    name: "Monsters Unchained",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-266",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0366.png",
    name: "Sugar Monster",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-267",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0368.png",
    name: "Hansel & Gretel Candyhouse",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-270",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0371.png",
    name: "Siren's Riches",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-271",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0443.png",
    name: "Spooky Carnival",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-272",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0372.png",
    name: "Dragon's Mirror",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-273",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0341.png",
    name: "Casino Spin",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-275",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0343.png",
    name: "Cobra Queen",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-276",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0344.png",
    name: "Cotton Gang Affair",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-277",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0346.png",
    name: "Dream Destiny",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-278",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0349.png",
    name: "Epic Treasure",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-279",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0362.png",
    name: "Wanted Wildz",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-280",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0380.png",
    name: "Sakura Masks",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-283",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0378.png",
    name: "The Wild Kiss",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-284",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0377.png",
    name: "Redline Rush",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-285",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0375.png",
    name: "777 Super Strike",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-286",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0430.png",
    name: "Clover Craze",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-287",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0376.png",
    name: "Midnight Romance",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-288",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0392.png",
    name: "Gold Mine Mistress",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-289",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0334.png",
    name: "80s Spins",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-290",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0337.png",
    name: "Ali Baba's Luck Megaways",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-291",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0338.png",
    name: "Ali Baba's Luck Power Reels",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-292",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0339.png",
    name: "Amazon Island Megaways",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-293",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0340.png",
    name: "Asian Fortune",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-294",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0342.png",
    name: "Chinese Wilds",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-295",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0348.png",
    name: "Elephant Treasure",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-298",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0395.png",
    name: "Fishtastic",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-299",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0350.png",
    name: "Golden Lamps",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-300",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0351.png",
    name: "Golden Toad",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-301",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0355.png",
    name: "Leprechauns Magic Megaways",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-302",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0356.png",
    name: "Leprechauns Magic Power Reels",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-303",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0357.png",
    name: "Lucky Carnival",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-304",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0358.png",
    name: "Macau Racing",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-305",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0381.png",
    name: "Midnight Thirst",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-306",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0361.png",
    name: "Red Hot Slot",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-309",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0439.png",
    name: "Wanted Wildz Extreme",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-310",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0390.png",
    name: "Fruit Flash",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-312",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0389.png",
    name: "Cannonball Cash",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-314",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0386.png",
    name: "Emperor of India",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-315",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0388.png",
    name: "Purr Power",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-317",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0383.png",
    name: "Sword Stomp",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-318",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0424.png",
    name: "Ultra Rich",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-320",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0385.png",
    name: "Buffalo Collector",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-321",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0384.png",
    name: "Fa Fa Babies 2",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-322",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0396.png",
    name: "Diamond Blitz 2",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-323",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0397.png",
    name: "Glow Dig",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-324",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0420.png",
    name: "Turtle Paradise",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-325",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0418.png",
    name: "Roman Emperors",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-326",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0398.png",
    name: "Savannah Pride",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-328",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0399.png",
    name: "Los Muertos Locos",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-329",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0400.png",
    name: "Moon Spell",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-330",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0404.png",
    name: "Diamond Doggies",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-332",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0403.png",
    name: "Sea Boat Adventure MegaWays™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-333",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0401.png",
    name: "Zeus Lightning MegaWays™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-334",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0406.png",
    name: "Dear Santa",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-336",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0473.png",
    name: "Cash Explorer",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-339",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0475.png",
    name: "Wild Touchdown Megaways",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-340",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0471.png",
    name: "Trick of the Dead Wild Candies Megaways",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-341",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0469.png",
    name: "Wild Hot Chilli Reels 2",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-342",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0477.png",
    name: "Trophy Fish",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-343",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0485.png",
    name: "Diamonds Up",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-346",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0481.png",
    name: "Serpent King",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-348",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0486.png",
    name: "Bass Boss MegaWays™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-350",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0492.png",
    name: "Jackrabbit Jackpots",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-356",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0490.png",
    name: "Farmtastic™",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-357",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/RT0408.png",
    name: "Gladiator Ways",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-359",
    cateogry: "RT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0002.png",
    name: "Sexy Vegas",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-002",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0003.png",
    name: "Roma",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-003",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0004.png",
    name: "Gold Rush Cowboy",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-004",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0005.png",
    name: "Wild Wet Win",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-005",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0006.png",
    name: "Royal Katt",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-006",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0007.png",
    name: "Rich Caishen",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-007",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0008.png",
    name: "Muay Thai Fighter",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-008",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0009.png",
    name: "Poker Ways",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-009",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0011.png",
    name: "Lucky Fortune",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-011",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0012.png",
    name: "Fruits Mania",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-012",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0013.png",
    name: "Fiery Lava",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-013",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0014.png",
    name: "God of Wealth",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-014",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0016.png",
    name: "Neon Fantasy",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-016",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0017.png",
    name: "Space Conquest",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-017",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0018.png",
    name: "Loki",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-018",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0019.png",
    name: "Fortune Lions",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-019",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0020.png",
    name: "Honey Trap",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-020",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0021.png",
    name: "Oceanic Melodies",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-021",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0022.png",
    name: "The Maya Myth",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-022",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0023.png",
    name: "Spin and Win",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-023",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0024.png",
    name: "Safari Blitz",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-024",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0025.png",
    name: "Goddess Of Egypt",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-025",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0026.png",
    name: "Heavenly Fortunes 2",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-026",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0027.png",
    name: "Ganesha Luck",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-027",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0028.png",
    name: "Heavenly Fortunes",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-028",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0029.png",
    name: "Mining Bonanza",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-029",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0030.png",
    name: "The Nutcrackers",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-030",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0031.png",
    name: "Legend of Nian",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-031",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0032.png",
    name: "The Great Safari",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-032",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0033.png",
    name: "Tiki Rush",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-033",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0034.png",
    name: "Neko Riches",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-034",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0035.png",
    name: "Mighty Sevens",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-035",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0036.png",
    name: "Mushroom Bandit",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-036",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0037.png",
    name: "City of Jewels",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-037",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0038.png",
    name: "Sweet Frenzy",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-038",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0039.png",
    name: "Leprechaun Bonanza",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-039",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0040.png",
    name: "Money Empire",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-040",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0041.png",
    name: "Yeti Boom",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-041",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0042.png",
    name: "Ranger Showdown",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-042",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0043.png",
    name: "Money Dragon",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-043",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0044.png",
    name: "Adventure To The West",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-044",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0046.png",
    name: "Caribbean Riches",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-046",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0047.png",
    name: "Mahjong Princess",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-047",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0050.png",
    name: "Apollo Ray of Luck",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-050",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0051.png",
    name: "Pumpkins Go Lucky",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-051",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0052.png",
    name: "Beasts Of Luck",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-052",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0053.png",
    name: "Guardian of The Museum",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-053",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0054.png",
    name: "Snake Treasure",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-054",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/FS0055.png",
    name: "Alien Smash",
    platForm: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-055",
    cateogry: "FASTSPIN",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/FortuneTreasure.webp",
    name: "FortuneTreasure",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-001",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/MoneyHorse.webp",
    name: "MoneyHorse",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-002",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/DragoNova.webp",
    name: "DragoNova",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-003",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/PowerFortune.webp",
    name: "PowerFortune",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-004",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/PowerLion.webp",
    name: "PowerLion",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-005",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Power Mask.webp",
    name: "Power Mask",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-006",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/FaFaDragon.webp",
    name: "FaFaDragon",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-007",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Gladiator.webp",
    name: "Gladiator",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-009",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/LuckyStar.webp",
    name: "LuckyStar",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-010",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Rolling 7.webp",
    name: "Rolling 7",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-011",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Thor Fortune.webp",
    name: "Thor Fortune",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-012",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Fancy Egypt.webp",
    name: "Fancy Egypt",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-013",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/FortuneCat.webp",
    name: "FortuneCat",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-014",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/CasinoFantasy.webp",
    name: "CasinoFantasy",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-015",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Golden Bunny.webp",
    name: "Golden Bunny",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-016",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/King Arthur Gold.webp",
    name: "King Arthur Gold",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-017",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Boom Boom Marmot.webp",
    name: "Boom Boom Marmot",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-018",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Golden Aztec.webp",
    name: "Golden Aztec",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-019",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Rolling Fortune.webp",
    name: "Rolling Fortune",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-020",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Mermaid Slingo.webp",
    name: "Mermaid Slingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-021",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Royal Ace.webp",
    name: "Royal Ace",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-022",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/MagicLamp.webp",
    name: "MagicLampLink",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-023",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Gladiator.webp",
    name: "GladiatorLink",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-024",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Super Egypt.webp",
    name: "Super Egypt",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-025",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Golden Aztec Mega.webp",
    name: "Golden Aztec Mega",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-026",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Sugar Crush.webp",
    name: "Sugar Crush",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-027",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Crazy Money.webp",
    name: "Crazy Money",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-029",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Lucky Meow.webp",
    name: "Lucky Meow",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-030",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Royal Hunter.webp",
    name: "Royal Hunter",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-031",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Dragon Gems.webp",
    name: "Dragon Gems",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-032",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/LIGHT OF APOLLO.webp",
    name: "LIGHT OF APOLLO",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-034",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Magical Alchemist.webp",
    name: "Magical Alchemist",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-035",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Dragon Gems Super Buy.webp",
    name: "Dragon Gems Super Buy",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-036",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Pirate Legends.webp",
    name: "Pirate Legends",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-037",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Dragon Gems Wheel.webp",
    name: "Dragon Gems Wheel",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-038",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Golden X Ace.webp",
    name: "Golden X Ace",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-042",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Fortune X Ace.webp",
    name: "Fortune X Ace",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-043",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Sexy Joker.webp",
    name: "Sexy Joker",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-044",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/TIGER BOOM.webp",
    name: "TIGER BOOM",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-046",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/yesbingo/Mega Bandit.webp",
    name: "Mega Bandit",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-047",
    cateogry: "YESBINGO",
    type: "SLOT",
  },
  {
    img: "/dataImages/fishing/FC0053.png",
    name: "Gods Grant Fortune",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-006",
    cateogry: "FC",
    type: "FISHING",
  },
  {
    img: "/dataImages/fishing/FC0027.png",
    name: "Star Hunter",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-004",
    cateogry: "FC",
    type: "FISHING",
  },
  {
    img: "/dataImages/fishing/FC0019.png",
    name: "Bao Chuan Fishing",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-002",
    cateogry: "FC",
    type: "FISHING",
  },
  {
    img: "/dataImages/fishing/FC0018.png",
    name: "Monkey King Fishing",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-001",
    cateogry: "FC",
    type: "FISHING",
  },
  {
    img: "/dataImages/slots/yesbingo/OceanPhoenix.webp",
    name: "OceanPhoenix",
    platForm: "YESBINGO",
    gameType: "FH",
    casinoType: "YesBingo-FH-001",
    cateogry: "YESBINGO",
    type: "FISHING",
  },
  {
    img: "/dataImages/fishing/YL0019.png",
    name: "Heroes of the Deep Sea",
    platForm: "YL",
    gameType: "FH",
    casinoType: "YL-FISH-005",
    cateogry: "YL",
    type: "FISHING",
  },
  {
    img: "/dataImages/fishing/YL0018.png",
    name: "Jackpot Fishery",
    platForm: "YL",
    gameType: "FH",
    casinoType: "YL-FISH-004",
    cateogry: "YL",
    type: "FISHING",
  },
  {
    img: "/dataImages/fishing/YL0017.png",
    name: "New Fishing Season",
    platForm: "YL",
    gameType: "FH",
    casinoType: "YL-FISH-003",
    cateogry: "YL",
    type: "FISHING",
  },
  {
    img: "/dataImages/fishing/YL0016.png",
    name: "Shark Hunter",
    platForm: "YL",
    gameType: "FH",
    casinoType: "YL-FISH-002",
    cateogry: "YL",
    type: "FISHING",
  },
  {
    img: "/dataImages/fishing/YL0010.png",
    name: "Fish Hunter 2",
    platForm: "YL",
    gameType: "FH",
    casinoType: "YL-FISH-001",
    cateogry: "YL",
    type: "FISHING",
  },
  {
    img: "/dataImages/fishing/FS0045.png",
    name: "Fishing Treasure",
    platForm: "FASTSPIN",
    gameType: "FH",
    casinoType: "FastSpin-FISH-001",
    cateogry: "FASTSPIN",
    type: "FISHING",
  },
  {
    img: "/dataImages/fishing/FS0046.png",
    name: "Ocean Carnival",
    platForm: "FASTSPIN",
    gameType: "FH",
    casinoType: "FastSpin-FISH-002",
    cateogry: "FASTSPIN",
    type: "FISHING",
  },
  {
    img: "/dataImages/slots/SS/SS01.webp",
    name: "JetX",
    platForm: "SMARTSOFT",
    gameType: "EGAME",
    casinoType: "SMARTSOFT-EGAME-001",
    cateogry: "SMARTSOFT",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/SS/SS02.webp",
    name: "Balloon",
    platForm: "SMARTSOFT",
    gameType: "EGAME",
    casinoType: "SMARTSOFT-EGAME-002",
    cateogry: "SMARTSOFT",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/SS/SS03.webp",
    name: "FootballX",
    platForm: "SMARTSOFT",
    gameType: "EGAME",
    casinoType: "SMARTSOFT-EGAME-003",
    cateogry: "SMARTSOFT",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/SS/SS04.webp",
    name: "PlinkoX",
    platForm: "SMARTSOFT",
    gameType: "EGAME",
    casinoType: "SMARTSOFT-EGAME-004",
    cateogry: "SMARTSOFT",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/SS/SS05.webp",
    name: "MineIsland",
    platForm: "SMARTSOFT",
    gameType: "EGAME",
    casinoType: "SMARTSOFT-EGAME-005",
    cateogry: "SMARTSOFT",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL03.webp",
    name: "Aviator",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-026",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL04.webp",
    name: "Crash",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-016",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL06.webp",
    name: "HILO",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-022",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL07.webp",
    name: "MahjongWays",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-027",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL08.webp",
    name: "KittyGold",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-019",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL09.webp",
    name: "Mines",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-013",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL10.webp",
    name: "Gems Miner",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-020",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL11.webp",
    name: "Dice",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-017",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL12.webp",
    name: "Plinko",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-018",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL13.webp",
    name: "Thai HILO",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-024",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL14.webp",
    name: "Tower",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-014",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL15.webp",
    name: "Tower2",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-023",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL16.webp",
    name: "Video Poker",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-025",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/YL/YL17.webp",
    name: "Wheel",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-021",
    cateogry: "YL",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/yesbingo/Crazy Color.webp",
    name: "Crazy Color",
    platForm: "YESBINGO",
    gameType: "EGAME",
    casinoType: "YesBingo-EGAME-001",
    cateogry: "YESBINGO",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/yesbingo/Diamond Mines.webp",
    name: "Diamond Mines",
    platForm: "YESBINGO",
    gameType: "EGAME",
    casinoType: "YesBingo-EGAME-002",
    cateogry: "YESBINGO",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/yesbingo/Money Blast.webp",
    name: "Money Blast",
    platForm: "YESBINGO",
    gameType: "EGAME",
    casinoType: "YesBingo-EGAME-003",
    cateogry: "YESBINGO",
    type: "EGAME",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-032.webp",
    name: "Mahjong Ways",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-032",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-001.webp",
    name: "Sugar Bliss",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-001",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-036.webp",
    name: "Mahjong Ways 2",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-036",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-030.webp",
    name: "Super Ace",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-030",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-031.webp",
    name: "Super Ace Deluxe",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-031",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-034.webp",
    name: "King Of Zeus",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-034",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-005.webp",
    name: "Planet Loots",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-005",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-002.webp",
    name: "Fa Fa Fa",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-002",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-029.webp",
    name: "Majestic Gems",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-029",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-004.webp",
    name: "Cai Shen Treasures",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-004",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-003.webp",
    name: "Dungeon Treasure",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-003",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-033.webp",
    name: "Big Bad Bass",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-033",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-035.webp",
    name: "Roma X",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-035",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-006.webp",
    name: "Hawaiian Loots",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-006",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-007.webp",
    name: "Royal Chess",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-007",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
  {
    img: "/dataImages/slots/MICROSLOT/MICRO-SLOT-008.webp",
    name: "Richie Rich Treasures",
    platForm: "MICROSLOT",
    gameType: "SLOT",
    casinoType: "MICRO-SLOT-008",
    cateogry: "MICROSLOT",
    type: "SLOT",
  },
];

export const homeFavouriteCasino = [
  {
    img: "../assets/images/JILI/JILI-TABLE-021.webp",
    name: "Ludo Quick",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-021",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-074.webp",
    name: "Ludo Quick",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-074",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-2.webp",
    name: "Cash Rocket",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-041",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-058.webp",
    name: "Ludo Quick",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-058",
    cateogry: "JILI",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/KM-TABLE-066.webp",
    name: "Coin Pusher",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-066",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-4.webp",
    name: "7 Up 7 Down",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-028",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-5.webp",
    name: "sicbo",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-015",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/TABLE-6.webp",
    name: "Coin Toss",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-036",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-073.webp",
    name: "Video Poker",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-073",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  // {
  //   img: "../assets/images/Table/TABLE-7.webp",
  //   name: "Cards Hi Lo",
  //   platForm: "KINGMAKER",
  //   gameType: "TABLE",
  //   casinoType: "KM-TABLE-037",
  //   cateogry: "KINGMAKER",
  //   type: "TABLE",
  // },
  {
    img: "../assets/images/Table/TABLE-3.webp",
    name: "Ludo",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-060",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/TABLE-9.webp",
    name: "Card Matka",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-022",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-021.webp",
    name: "Number Matka",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-021",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-032.webp",
    name: "Andar Bahar",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-032",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-12.webp",
    name: "Bonus Dice",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-043",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-13.webp",
    name: "32 Cards",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-039",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-040.webp",
    name: "Plinko",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-040",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-067.webp",
    name: "Cockfighting Arena",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-067",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-16.webp",
    name: "Colour Game",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-050",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/JILI-TABLE-047.png",
    name: "Crash Bonus",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-047",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/JILI-TABLE-042.png",
    name: "Mini Flush",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-042",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-012.webp",
    name: "Dragon & Tiger",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-012",
    cateogry: "JILI",
    type: "TABLE",
  },
  // {
  //   img: "../assets/images/Table/JILI-TABLE-033.png",
  //   name: "Mines",
  //   platForm: "JILI",
  //   gameType: "TABLE",
  //   casinoType: "JILI-TABLE-033",
  //   cateogry: "JILI",
  //   type: "TABLE",
  // },
  // {
  //   img: "../assets/images/slot/KM-SLOT-005.webp",
  //   name: "Rooster",
  //   platForm: "KINGMAKER",
  //   gameType: "SLOT",
  //   casinoType: "KM-SLOT-005",
  //   cateogry: "KINGMAKER",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/NETENT-SLOT-008.png",
  //   name: "Starburst™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-008",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/NETENT-SLOT-017.png",
    name: "Starburst™ XXXtreme",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-017",
    cateogry: "NETENT",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/NETENT-SLOT-009.png",
  //   name: "Gonzo's Quest™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-009",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },

  {
    img: "../assets/images/slot/NETENT-SLOT-014.png",
    name: "Divine Fortune™ Megaways™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-014",
    cateogry: "NETENT",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/NETENT-SLOT-013.png",
  //   name: "Divine Fortune™ Megaways™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-013",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },

  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-076.webp",
    name: "Super Hoo Hey How",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-076",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/KM-SLOT-002.webp",
    name: "Rooster",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-002",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/KM-SLOT-006.webp",
    name: "Rooster",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-006",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

  // {
  //   img: "../assets/images/slot/NETENT-SLOT-010.png",
  //   name: "Finn's Golden Tavern™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-010",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/NETENT-SLOT-018.png",
  //   name: "Twin Spin™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-018",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/NETENT-SLOT-025.png",
  //   name: "Jimi Hendrix Online Slot™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-025",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },

  {
    img: "../assets/images/slot/NETENT-SLOT-006.png",
    name: "Parthenon: Quest for Immortality™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-006",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-177.webp",
    name: "101 Candies",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-177",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-178.webp",
    name: "Big Bang Boom",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-178",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-450.webp",
    name: "Big Bang Boom",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-450",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-038.webp",
    name: "Big Bang Boom",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-038",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-180.webp",
    name: "Jack and the Beanstalk Remastered",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-180",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-181.webp",
    name: "Thrill to Grill™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-181",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-082.webp",
    name: "Football Rules",
    platForm: "PLAYTECH",
    gameType: "SLOT",
    casinoType: "PT-SLOT-082",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-003.webp",
    name: "777",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-003",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-012.webp",
    name: "Over Dragon's Gate",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-012",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-004.webp",
    name: "Get Money",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-004",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-002.webp",
    name: "Phoenix",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-002",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-011.webp",
    name: "Diamond Mogul",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-011",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-005.webp",
    name: "Rich Now",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-005",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-008.webp",
    name: "Dracula",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-008",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/Egame/22001.png",
    name: "Aviator",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22005.png",
    name: "Mines",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-005",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22004.png",
    name: "Plinko",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-004",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22006.png",
    name: "Spribe Hilo",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-006",
    cateogry: "SPRIBE",
    type: "EGAME",
  },

  {
    img: "../assets/images/Egame/22008.png",
    name: "Mini Roulette",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-008",
    cateogry: "SPRIBE",
    type: "EGAME",
  },

  // Egame Start JDB (casino Done) -----
  {
    img: "../assets/images/Egame/JDB-EGAME-002.webp",
    name: "Lucky Color Game",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-009",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-006.webp",
    name: "King Of Football",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-010",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-001.webp",
    name: "Crazy King Kong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-011",
    cateogry: "JDB",
    type: "EGAME",
  },

  {
    img: "../assets/images/Egame/JDB-EGAME-007.webp",
    name: "Super Super Fruit",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-012",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-011.webp",
    name: "Jogo Do Bicho",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-013",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-010.webp",
    name: "Beer Tycoon",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-014",
    cateogry: "JDB",
    type: "EGAME",
  },

  {
    img: "../assets/images/Egame/PP-EGAME-004.webp",
    name: "Fantastic League",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-001",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-002.webp",
    name: "Penalty Shootout",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-002",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-005.webp",
    name: "Greyhound Racing",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-005",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-003.webp",
    name: "Horse Racing",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-003",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-006.webp",
    name: "Force 1",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-006",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-007.webp",
    name: "Darts",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-007",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-017.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-017",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-012.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-012",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-013.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-013",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-014.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-014",
    cateogry: "JDB",
    type: "EGAME",
  },
];
export const bannerSlider = [
  { id: 1, img: banner1, cateogry: "live", type: "EVO" },
  { id: 2, img: banner2, cateogry: "live", type: "" },
  {
    id: 3,
    img: banner3,
    cateogry: "slot",
    type: "NETENT",
  },
  // {
  //   id: 4,
  //   img: banner4,
  //   cateogry: "egame",
  //   type: "SPRIBE",
  // },
  {
    id: 5,
    img: banner5,
    cateogry: "egame",
    type: "JDB",
  },
  {
    id: 5,
    img: banner6,
    cateogry: "live",
    type: "HOTROAD",
  },
   {
    id: 5,
    img: banner7,
    cateogry: "live",
    type: "SMARTSOFT",
  },
];

export const showMenuUsingPath = [{ path: "/change-password" }, { path: "" }];

export const Dummy = [
  {
    timestamp: "2025-03-06T02:45:00.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c2c09eb8986556deeb6",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c2c09eb8986556deeb7",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c2c09eb8986556deeb8",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c2c09eb8986556deeb9",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c2c09eb8986556deeba",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c2c09eb8986556deebb",
          },
        ],
        _id: "67c90c2c09eb8986556deeb5",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c2c09eb8986556deebd",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c2c09eb8986556deebe",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c2c09eb8986556deebf",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c2c09eb8986556deec0",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c2c09eb8986556deec1",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c2c09eb8986556deec2",
          },
        ],
        _id: "67c90c2c09eb8986556deebc",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c2c09eb8986556deec4",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c2c09eb8986556deec5",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c2c09eb8986556deec6",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c2c09eb8986556deec7",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c2c09eb8986556deec8",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c2c09eb8986556deec9",
          },
        ],
        _id: "67c90c2c09eb8986556deec3",
      },
    ],
    _id: "67c90c2c09eb8986556deeb4",
  },
  {
    timestamp: "2025-03-06T02:45:01.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c2d09eb8986556defbd",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c2d09eb8986556defbe",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c2d09eb8986556defbf",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c2d09eb8986556defc0",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c2d09eb8986556defc1",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c2d09eb8986556defc2",
          },
        ],
        _id: "67c90c2d09eb8986556defbc",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c2d09eb8986556defc4",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c2d09eb8986556defc5",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c2d09eb8986556defc6",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c2d09eb8986556defc7",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c2d09eb8986556defc8",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c2d09eb8986556defc9",
          },
        ],
        _id: "67c90c2d09eb8986556defc3",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c2d09eb8986556defcb",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c2d09eb8986556defcc",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c2d09eb8986556defcd",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c2d09eb8986556defce",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c2d09eb8986556defcf",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c2d09eb8986556defd0",
          },
        ],
        _id: "67c90c2d09eb8986556defca",
      },
    ],
    _id: "67c90c2d09eb8986556defbb",
  },
  {
    timestamp: "2025-03-06T02:45:02.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c2e09eb8986556df08d",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c2e09eb8986556df08e",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c2e09eb8986556df08f",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c2e09eb8986556df090",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c2e09eb8986556df091",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c2e09eb8986556df092",
          },
        ],
        _id: "67c90c2e09eb8986556df08c",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c2e09eb8986556df094",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c2e09eb8986556df095",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c2e09eb8986556df096",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c2e09eb8986556df097",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c2e09eb8986556df098",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c2e09eb8986556df099",
          },
        ],
        _id: "67c90c2e09eb8986556df093",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c2e09eb8986556df09b",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c2e09eb8986556df09c",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c2e09eb8986556df09d",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c2e09eb8986556df09e",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c2e09eb8986556df09f",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c2e09eb8986556df0a0",
          },
        ],
        _id: "67c90c2e09eb8986556df09a",
      },
    ],
    _id: "67c90c2e09eb8986556df08b",
  },
  {
    timestamp: "2025-03-06T02:45:03.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c2f09eb8986556df18d",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c2f09eb8986556df18e",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c2f09eb8986556df18f",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c2f09eb8986556df190",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c2f09eb8986556df191",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c2f09eb8986556df192",
          },
        ],
        _id: "67c90c2f09eb8986556df18c",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c2f09eb8986556df194",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c2f09eb8986556df195",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c2f09eb8986556df196",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c2f09eb8986556df197",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c2f09eb8986556df198",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c2f09eb8986556df199",
          },
        ],
        _id: "67c90c2f09eb8986556df193",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c2f09eb8986556df19b",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c2f09eb8986556df19c",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c2f09eb8986556df19d",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c2f09eb8986556df19e",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c2f09eb8986556df19f",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c2f09eb8986556df1a0",
          },
        ],
        _id: "67c90c2f09eb8986556df19a",
      },
    ],
    _id: "67c90c2f09eb8986556df18b",
  },
  {
    timestamp: "2025-03-06T02:45:04.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3009eb8986556df2d2",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3009eb8986556df2d3",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3009eb8986556df2d4",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3009eb8986556df2d5",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3009eb8986556df2d6",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3009eb8986556df2d7",
          },
        ],
        _id: "67c90c3009eb8986556df2d1",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3009eb8986556df2d9",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3009eb8986556df2da",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3009eb8986556df2db",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3009eb8986556df2dc",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3009eb8986556df2dd",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3009eb8986556df2de",
          },
        ],
        _id: "67c90c3009eb8986556df2d8",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3009eb8986556df2e0",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3009eb8986556df2e1",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3009eb8986556df2e2",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3009eb8986556df2e3",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3009eb8986556df2e4",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3009eb8986556df2e5",
          },
        ],
        _id: "67c90c3009eb8986556df2df",
      },
    ],
    _id: "67c90c3009eb8986556df2d0",
  },
  {
    timestamp: "2025-03-06T02:45:05.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3109eb8986556df3c2",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3109eb8986556df3c3",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3109eb8986556df3c4",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3109eb8986556df3c5",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3109eb8986556df3c6",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3109eb8986556df3c7",
          },
        ],
        _id: "67c90c3109eb8986556df3c1",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3109eb8986556df3c9",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3109eb8986556df3ca",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3109eb8986556df3cb",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3109eb8986556df3cc",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3109eb8986556df3cd",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3109eb8986556df3ce",
          },
        ],
        _id: "67c90c3109eb8986556df3c8",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3109eb8986556df3d0",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3109eb8986556df3d1",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3109eb8986556df3d2",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3109eb8986556df3d3",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3109eb8986556df3d4",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3109eb8986556df3d5",
          },
        ],
        _id: "67c90c3109eb8986556df3cf",
      },
    ],
    _id: "67c90c3109eb8986556df3c0",
  },
  {
    timestamp: "2025-03-06T02:45:06.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3209eb8986556df4e0",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3209eb8986556df4e1",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3209eb8986556df4e2",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3209eb8986556df4e3",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3209eb8986556df4e4",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3209eb8986556df4e5",
          },
        ],
        _id: "67c90c3209eb8986556df4df",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3209eb8986556df4e7",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3209eb8986556df4e8",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3209eb8986556df4e9",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3209eb8986556df4ea",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3209eb8986556df4eb",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3209eb8986556df4ec",
          },
        ],
        _id: "67c90c3209eb8986556df4e6",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3209eb8986556df4ee",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3209eb8986556df4ef",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3209eb8986556df4f0",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3209eb8986556df4f1",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3209eb8986556df4f2",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3209eb8986556df4f3",
          },
        ],
        _id: "67c90c3209eb8986556df4ed",
      },
    ],
    _id: "67c90c3209eb8986556df4de",
  },
  {
    timestamp: "2025-03-06T02:45:07.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3309eb8986556df5d7",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3309eb8986556df5d8",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3309eb8986556df5d9",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3309eb8986556df5da",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3309eb8986556df5db",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3309eb8986556df5dc",
          },
        ],
        _id: "67c90c3309eb8986556df5d6",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3309eb8986556df5de",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3309eb8986556df5df",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3309eb8986556df5e0",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3309eb8986556df5e1",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3309eb8986556df5e2",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3309eb8986556df5e3",
          },
        ],
        _id: "67c90c3309eb8986556df5dd",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3309eb8986556df5e5",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3309eb8986556df5e6",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3309eb8986556df5e7",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3309eb8986556df5e8",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3309eb8986556df5e9",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3309eb8986556df5ea",
          },
        ],
        _id: "67c90c3309eb8986556df5e4",
      },
    ],
    _id: "67c90c3309eb8986556df5d5",
  },
  {
    timestamp: "2025-03-06T02:45:08.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3409eb8986556df6a0",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3409eb8986556df6a1",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3409eb8986556df6a2",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3409eb8986556df6a3",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3409eb8986556df6a4",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3409eb8986556df6a5",
          },
        ],
        _id: "67c90c3409eb8986556df69f",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3409eb8986556df6a7",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3409eb8986556df6a8",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3409eb8986556df6a9",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3409eb8986556df6aa",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3409eb8986556df6ab",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3409eb8986556df6ac",
          },
        ],
        _id: "67c90c3409eb8986556df6a6",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3409eb8986556df6ae",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3409eb8986556df6af",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3409eb8986556df6b0",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3409eb8986556df6b1",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3409eb8986556df6b2",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3409eb8986556df6b3",
          },
        ],
        _id: "67c90c3409eb8986556df6ad",
      },
    ],
    _id: "67c90c3409eb8986556df69e",
  },
  {
    timestamp: "2025-03-06T02:45:09.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3509eb8986556df7c7",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3509eb8986556df7c8",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3509eb8986556df7c9",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3509eb8986556df7ca",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3509eb8986556df7cb",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3509eb8986556df7cc",
          },
        ],
        _id: "67c90c3509eb8986556df7c6",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3509eb8986556df7ce",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3509eb8986556df7cf",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3509eb8986556df7d0",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3509eb8986556df7d1",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3509eb8986556df7d2",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3509eb8986556df7d3",
          },
        ],
        _id: "67c90c3509eb8986556df7cd",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3509eb8986556df7d5",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3509eb8986556df7d6",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3509eb8986556df7d7",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3509eb8986556df7d8",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3509eb8986556df7d9",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3509eb8986556df7da",
          },
        ],
        _id: "67c90c3509eb8986556df7d4",
      },
    ],
    _id: "67c90c3509eb8986556df7c5",
  },
  {
    timestamp: "2025-03-06T02:45:10.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3609eb8986556df8a0",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3609eb8986556df8a1",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3609eb8986556df8a2",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3609eb8986556df8a3",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3609eb8986556df8a4",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3609eb8986556df8a5",
          },
        ],
        _id: "67c90c3609eb8986556df89f",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3609eb8986556df8a7",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3609eb8986556df8a8",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3609eb8986556df8a9",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3609eb8986556df8aa",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3609eb8986556df8ab",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3609eb8986556df8ac",
          },
        ],
        _id: "67c90c3609eb8986556df8a6",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3609eb8986556df8ae",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3609eb8986556df8af",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3609eb8986556df8b0",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3609eb8986556df8b1",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3609eb8986556df8b2",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3609eb8986556df8b3",
          },
        ],
        _id: "67c90c3609eb8986556df8ad",
      },
    ],
    _id: "67c90c3609eb8986556df89e",
  },
];
